export const Colegioheaders = [
  {
    text: "colegio",
    value: "nombre_colegio",
    class: "header_datatable",
    fixed: true,
  },
  {
    text: "ruc",
    value: "ruc_colegio",
    class: "header_datatable",
    fixed: false,
  },
  {
    text: "correo",
    value: "correo_colegio",
    class: "header_datatable",
    fixed: false,
  },
  { text: "sitio Web", value: "web", class: "header_datatable", fixed: false },
  {
    text: "tipo",
    align: "center",
    value: "tipo",
    sortable: false,
    fixed: false,
    class: "header_datatable",
  },
  {
    text: "SEDES",
    align: "center",
    value: "sucursal",
    sortable: false,
    fixed: false,
    class: "header_datatable",
  },
  {
    text: "ver",
    value: "action_ver",
    sortable: false,
    fixed: false,
    align: "center",
    class: "header_datatable",
  },
  {
    text: "editar",
    value: "action_editar",
    sortable: false,
    fixed: false,
    align: "center",
    class: "header_datatable",
  },
  {
    text: "configurar módulos",
    value: "action_config",
    sortable: false,
    fixed: false,
    align: "center",
    class: "header_datatable",
  },
];


export const BancotesoreriaHeaders = [
  { text: "ID", value: "id_config_banco", class: "header_datatable" },
  { text: "BANCO", value: "nombre_banco", class: "header_datatable" },
  { text: "CUENTA CORRIENTE", value: "cuenta_corriente", class: "header_datatable" },
  { text: "DESCRIPCIÓN", value: "descripcion", class: "header_datatable" },
  { text: "MONEDA", value: "nombre_moneda", class: "header_datatable" },
  { text: "LOCAL", value: "direccion", class: "header_datatable" },
  { text: "EDITAR", value: "action_editar", sortable: false, align: "center", class: "header_datatable", width: "1" }
];

export const TalonariotesoreriaHeaders = [
  { text: "ID", value: "id_config_talonario", class: "header_datatable" },
  { text: "DOCUMENTOS", value: "nombre_tipo_documento", class: "header_datatable" },
  { text: "SERIE", value: "serie", class: "header_datatable" },
  { text: "NÚMERO", value: "numero", class: "header_datatable" },
  { text: "DESCRIPCIÓN", value: "descripcion", class: "header_datatable" },
  { text: "CÓDIGO SUNAT", value: "codigo_sunat", align: "center", class: "header_datatable" },
  { text: "EDITAR", value: "action_editar", sortable: false, align: "center", class: "header_datatable", width: "1" }
];

export const IEgresostesoreriaHeaders = [
  { text: "CÓDIGO", value: "codigo", class: "header_datatable" },
  { text: "CONCEPTO DE FACTURACIÓN", value: "concepto", class: "header_datatable" },
  { text: "TIPO", value: "nombre_tipo_concepto", class: "header_datatable" },
  { text: "DESCRIPCIÓN", value: "descripcion", class: "header_datatable" },
  { text: "MONTO", value: "monto", align: "center", class: "header_datatable" },
  { text: "USO", value: "uso", align: "center", class: "header_datatable" },
  { text: "IGV", value: "igv", align: "center", class: "header_datatable" },
  { text: "EDITAR", value: "action_editar", sortable: false, align: "center", class: "header_datatable", width: "1" }
];

export const ProveedoresTesoreriaHeaders = [
  { text: "RUC", value: "ruc", class: "header_datatable" },
  { text: "PROVEEDOR", value: "nombre_proveedor", class: "header_datatable" },
  { text: "TELÉFONO", value: "telefono", class: "header_datatable" },
  { text: "CORREO ELECTRÓNICO", value: "correo", class: "header_datatable" },
  { text: "ESTADO", value: "estado", align: "center", class: "header_datatable" },
  { text: "EDITAR", value: "action_editar", sortable: false, align: "center", class: "header_datatable", width: "1" }
];

export const PromocionesTesoreriaHeaders = [
  { text: "CÓDIGO", value: "id_config_promociones", class: "header_datatable" },
  { text: "CONCEPTO DE PROMOCIÓN", value: "concepto", class: "header_datatable" },
  { text: "AÑO", value: "nom_anolectivo", class: "header_datatable" },
  { text: "MES", value: "nombre_mes", class: "header_datatable" },
  { text: "MONTO", value: "monto", class: "header_datatable" },
  { text: "EDITAR", value: "action_editar", sortable: false, align: "center", class: "header_datatable", width: "1" }
];

export const TipoMoraHeaders = [
  { text: "AÑO", value: "nom_anolectivo", class: "header_datatable" },
  { text: "MES", value: "nombre_mes", class: "header_datatable" },
  { text: "TIPO DE MORA", value: "nombre_tipo_mora", class: "header_datatable" },
  { text: "MONEDA", value: "nombre_moneda", class: "header_datatable" },
  { text: "TARIFA", value: "tarifa_mora", class: "header_datatable" },
  { text: "OBSERVACIÓN", value: "observación", class: "header_datatable" },
  { text: "EDITAR", value: "action_editar", sortable: false, align: "center", class: "header_datatable", width: "1" }
];

// tesoreria asignacion headers

export const ProvisionesTesoreriaHeaders = [
  { text: "AÑO", value: "nom_anolectivo", class: "header_datatable" },
  { text: "NIVEL", value: "desc_nivel", class: "header_datatable" },
  { text: "GRADO", value: "desc_grado", class: "header_datatable" },
  { text: "SECCIÓN", value: "nombre_seccion", class: "header_datatable" },
  { text: "TURNO", value: "desc_turno", class: "header_datatable" },
  { text: "CONCEPTO", value: "concepto", class: "header_datatable" },
  { text: "NOMBRES Y APELLIDOS", value: "nombre_estudiante", class: "header_datatable" },
  { text: "MONEDA", value: "nombre_moneda", class: "header_datatable" },
  { text: "MONTO", value: "monto", class: "header_datatable" },
  { text: "GENERAR", value: "action_generar", sortable: false, align: "center", class: "header_datatable ", width: "20" },
  { text: "EDITAR", value: "action_editar", sortable: false, align: "center", class: "header_datatable", width: "10" }
];

export const BecadosTesoreriaHeaders = [
  { text: "ID", value: "id_asig_becado", class: "header_datatable" },
  { text: "APELLIDOS Y NOMBRES", value: "nombre_becado", class: "header_datatable" },
  { text: "MES DE INICIO", value: "nombre_mes_inicio", class: "header_datatable" },
  { text: "MES DE FINALIZACIÓN", value: "nombre_mes_final", class: "header_datatable" },
  { text: "TIPO DE BECA", value: "nombre_tipo_beca", class: "header_datatable" },
  { text: "MOTIVO DE LA BECA", value: "motivo_beca", sortable: false, class: "header_datatable" },
  { text: "MONEDA", value: "nombre_moneda", sortable: false, class: "header_datatable" },
  { text: "MONTO", value: "monto", sortable: false, class: "header_datatable" },
  { text: "EDITAR", value: "action_editar", sortable: false, align: "center", class: "header_datatable", width: "1" }
];

export const ProvisionesDetHeaders = [
  { text: "MES", value: "nombre_mes", sortable: false, class: "header_datatable" },
  { text: "FECHA DE CREACIÓN", value: "fecha_generado", sortable: false, align: "center", class: "header_datatable" },
  { text: "FECHA DE VENCIMIENTO", value: "fecha_vencimiento", sortable: false, align: "center", class: "header_datatable" }
];

export const DeudasTesoHeaders = [
  { text: "AÑO", value: "nom_anolectivo", class: "header_datatable", sortable: false, },
  { text: "NIVEL", value: "desc_nivel", class: "header_datatable", sortable: false, },
  { text: "GRADO", value: "desc_grado", class: "header_datatable", sortable: false, },
  { text: "SECCIÓN", value: "nombre_seccion", class: "header_datatable", sortable: false, },
  { text: "NOMBRES Y APELLIDOS", value: "nombre_estudiante", class: "header_datatable", sortable: false, },
  { text: "CONCEPTO", value: "concepto", class: "header_datatable", sortable: false, },
  { text: "FECHA DE VENCIMIENTO", value: "fecha_vencimiento", sortable: false, class: "header_datatable" },
  { text: "MONEDA", value: "nombre_moneda", sortable: false, class: "header_datatable" },
  { text: "MONTO", value: "monto", sortable: false, class: "header_datatable" },
  { text: "ESTADO", value: "estado", sortable: false, class: "header_datatable" },
  { text: "EDITAR", value: "action_editar", sortable: false, align: "center", class: "header_datatable", width: "1" }
];

export const DeudasBancosHeaders = [
  { text: "BANCO", value: "nombre_banco", class: "header_datatable", sortable: false },
  { text: "AÑO", value: "nom_anolectivo", class: "header_datatable", sortable: false },
  { text: "NIVEL", value: "desc_nivel", class: "header_datatable", sortable: false },
  { text: "GRADO", value: "desc_grado", class: "header_datatable", sortable: false },
  { text: "SECCIÓN", value: "nombre_seccion", class: "header_datatable", sortable: false },
  { text: "NOMBRES Y APELLIDOS", value: "nombre_estudiante", class: "header_datatable", sortable: false },
  { text: "CONCEPTO", value: "concepto", class: "header_datatable", sortable: false },
  { text: "FECHA DE VENCIMIENTO", value: "fecha_vencimiento", sortable: false, class: "header_datatable" },
  { text: "MONEDA", value: "nombre_moneda", sortable: false, class: "header_datatable" },
  { text: "MONTO", value: "monto", sortable: false, class: "header_datatable" },
  { text: "MORA", value: "monto_mora", sortable: false, class: "header_datatable" },
  { text: "DTO", value: "dcto", sortable: false, class: "header_datatable" }
];

export const BoletaLotesHeaders = [
  { text: "AÑO", value: "nom_anolectivo", class: "header_datatable", sortable: false },
  { text: "MES", value: "nombre_mes", class: "header_datatable", sortable: false },
  { text: "NIVEL", value: "desc_nivel", class: "header_datatable", sortable: false },
  { text: "GRADO", value: "desc_grado", class: "header_datatable", sortable: false },
  { text: "SECCIÓN", value: "nombre_seccion", class: "header_datatable", sortable: false },
  { text: "NOMBRES Y APELLIDOS", value: "nombre_estudiante", class: "header_datatable", sortable: false },
  { text: "CONCEPTO", value: "concepto", class: "header_datatable", sortable: false },
  { text: "FECHA DE VENCIMIENTO", value: "fecha_vencimiento", sortable: false, class: "header_datatable" },
  { text: "METODO DE PAGO", value: "nombre_metodo_pago", sortable: false, class: "header_datatable" },
  { text: "MONEDA", value: "nombre_moneda", sortable: false, class: "header_datatable" },
  { text: "MONTO PAGADO", value: "monto", sortable: false, class: "header_datatable" },
];

export const DocumentosRequeridosHeaders = [
  /*  { text: 'ID', align: 'left', sortable: false, value: 'id', class:'secondary'}, */
  {
    text: "AÑO ACADÉMICO",
    value: "ano_academico",
    class: "header_datatable",
  },
  {
    text: "DOCUMENTOS REQUERIDOS",
    value: "desc_documentos_requeridos",
    class: "header_datatable",
  },
  {
    text: "EDITAR",
    value: "action_editar",
    sortable: false,
    align: "center",
    class: "header_datatable",
    width: "2",
  },
  {
    text: "ELIMINAR",
    value: "action_borrar",
    sortable: false,
    align: "center",
    class: "header_datatable",
    width: "2",
  },
];

export const AsignacionDocenteHeadersProfesores = [
  /* { text: "#", align: "left", sortable: false, value: "id" }, */
  {
    text: "N.° DOCUMENTO DE IDENTIDAD",
    value: "numdoc_persona",
    class: "header_datatable",
  },
  {
    text: "APELLIDOS Y NOMBRES",
    value: "action_apellido_nombre",
    class: "header_datatable",
  },
  {
    text: "teléfono móvil",
    value: "telf_persona",
    class: "header_datatable",
  },
  {
    text: "CORREO ELECTRÓNICO",
    value: "correo_persona",
    class: "header_datatable",
  },
  {
    text: "",
    align: "center",
    value: "action",
    sortable: false,
    class: "header_datatable",
  },

  {
    text: "VER",
    align: "center",
    value: "action_ver",
    sortable: false,
    class: "header_datatable",
  },

  {
    text: "EDITAR",
    align: "center",
    value: "action_editar",
    sortable: false,
    class: "header_datatable",
  },
];



export const CondicionAmisionHeaders = [
  /*  { text: 'ID', align: 'left', sortable: false, value: 'id', class:'secondary'}, */
  { text: 'AÑO ACADÉMICO', value: 'admision.ano_academico', class: 'header_datatable' },
  { text: 'NIVEL', value: 'nivel.desc_nivel', class: 'header_datatable' },
  { text: 'GRADOS', value: 'grados', class: 'header_datatable' },
  { text: 'EDITAR', value: 'action_editar', sortable: false, align: 'center', class: 'header_datatable', width: '2' },
  { text: 'VISUALIZAR', value: 'action_ver', sortable: false, align: 'center', class: 'header_datatable', width: '2' },
  { text: 'ELIMINAR', value: 'action_borrar', sortable: false, align: 'center', class: 'header_datatable', width: '2' }
];

export const FechasEntrevistasHeaders = [
  /*  { text: 'ID', align: 'left', sortable: false, value: 'id', class:'secondary'}, */
  {
    text: "AÑO ACADÉMICO",
    value: "ano_academico",
    class: "header_datatable",
  },
  {
    text: "DESCRIPCIÓN",
    value: "descripcion",
    class: "header_datatable",
  },
  { text: "DESDE", value: "desde", class: "header_datatable" },
  { text: "HASTA", value: "hasta", class: "header_datatable" },
  {
    text: "EDITAR",
    value: "action_editar",
    sortable: false,
    align: "center",
    class: "header_datatable",
    width: "2",
  },
  {
    text: "VISUALIZAR",
    value: "action_ver",
    sortable: false,
    align: "center",
    class: "header_datatable",
    width: "2",
  },
  {
    text: "ELIMINAR",
    value: "action_borrar",
    sortable: false,
    align: "center",
    class: "header_datatable",
    width: "2",
  },
];

export const DocuemntosFotosRequeridosHeaders = [
  /*  { text: 'ID', align: 'left', sortable: false, value: 'id', class:'secondary'}, */
  {
    text: "AÑO ACADÉMICO",
    value: "admision.ano_academico",
    class: "header_datatable",
  },
  {
    text: "TÍTULO",
    value: "titulo",
    class: "header_datatable",
  },
  {
    text: "EDITAR",
    value: "action_editar",
    sortable: false,
    align: "center",
    class: "header_datatable",
    width: "2",
  },
  {
    text: "VISUALIZAR",
    value: "action_ver",
    sortable: false,
    align: "center",
    class: "header_datatable",
    width: "2",
  },
  {
    text: "ELIMINAR",
    value: "action_borrar",
    sortable: false,
    align: "center",
    class: "header_datatable",
    width: "2",
  },
];

export const ConfigAdmisionHeaders = [
  /*  { text: 'ID', align: 'left', sortable: false, value: 'id', class:'secondary'}, */
  {
    text: "AÑO ACADÉMICO",
    value: "ano_academico",
    class: "header_datatable",
  },
  {
    text: "ENCABEZADO",
    value: "encabezado",
    class: "header_datatable",
  },
  { text: "ESTADO", value: "activo", class: "header_datatable" },
  {
    text: "EDITAR",
    value: "action_editar",
    sortable: false,
    align: "center",
    class: "header_datatable",
    width: "2",
  },
  {
    text: "VISUALIZAR",
    value: "action_ver",
    sortable: false,
    align: "center",
    class: "header_datatable",
    width: "2",
  },
  {
    text: "ELIMINAR",
    value: "action_borrar",
    sortable: false,
    align: "center",
    class: "header_datatable",
    width: "2",
  },
];

export const LicenciasHeaders = [
  /* { text: 'ID', align: 'left', value: 'id', class:'secondary'}, */
  {
    text: "colegio",
    value: "nombre_colegio",
    class: "header_datatable",
  },
  {
    text: "tipo de licencia",
    value: "desc_tipo_licencia",
    class: "header_datatable",
  },
  {
    text: "serie",
    value: "serie_licencia",
    class: "header_datatable",
  },
  {
    text: "fecha de inicio",
    value: "fecha_inicioFiltro",
    class: "header_datatable",
  },
  {
    text: "fecha de fin",
    value: "fecha_finFiltro",
    sortable: false,
    class: "header_datatable",
  },
  {
    text: "estado",
    value: "estadoValor",
    sortable: false,
    align: "center",
    class: "header_datatable",
  },
  {
    text: "editar",
    value: "action_editar",
    sortable: false,
    align: "center",
    class: "header_datatable",
    width: "1",
  },
  {
    text: "borrar",
    value: "action_borrar",
    sortable: false,
    align: "center",
    class: "header_datatable",
    width: "1",
  },
];

export const LicenciatipoHeaders = [
  /* {text: 'ID', align: 'left', value: 'id', class:'secondary'}, */
  {
    text: "nombre",
    value: "desc_tipo_licencia",
    class: "header_datatable",
  },
  {
    text: "Colegio",
    value: "nombre_colegio",
    class: "header_datatable",
  },
  {
    text: "días de duracion",
    value: "duracion_licencia",
    class: "header_datatable",
  },
  {
    text: "estado",
    value: "estadoValor",
    sortable: false,
    align: "center",
    class: "header_datatable",
  },
  {
    text: "editar",
    value: "action_editar",
    sortable: false,
    align: "center",
    class: "header_datatable",
    width: "1",
  },
  {
    text: "borrar",
    value: "action_borrar",
    sortable: false,
    align: "center",
    class: "header_datatable",
    width: "1",
  },
];

export const GestionUsuarioWMHeaders = [
  /* { text: 'ID', align: 'left', value: 'id', class:'secondary'}, */
  {
    text: "N.° DOCUMENTO DE IDENTIDAD",
    value: "numdoc_persona",
    class: "header_datatable",
    sortable: true
  },
  {
    text: "APELLIDOS Y NOMBRES",
    value: "apellido_nombre",
    class: "header_datatable",
    sortable: true
  },
  { text: "USUARIO", value: "usu_usuario", class: "header_datatable", sortable: true },
  {
    text: "PERFIL",
    value: "descripcion_perfil",
    class: "header_datatable",
    sortable: true
  },
  {
    text: "CELULAR",
    value: "telf_persona",
    class: "header_datatable",
    sortable: true
  },
  {
    text: "ESTADO",
    value: "estado_usuario",
    align: "center",
    class: "header_datatable",
  },
  {
    text: "EDITAR",
    value: "action_editar",
    sortable: false,
    align: "center",
    class: "header_datatable",
    width: "60",
  },
  {
    text: "ELIMINAR",
    value: "action_borrar",
    sortable: false,
    align: "center",
    class: "header_datatable",
    width: "60",
  },
  // {
  //   text: "configurar",
  //   value: "action_config",
  //   sortable: false,
  //   align: "center",
  //   class: "header_datatable",
  //   width: "60",
  // },
];

export const GestionusuariosHeaders = [
  /*  { text: 'ID', align: 'left', value: 'id', class:'header_datatable'}, */
  {
    text: "n° de documento",
    value: "numdoc_persona",
    class: "header_datatable",
    sortable: true,
  },
  {
    text: "apellidos y nombres",
    value: "apellido_nombre",
    class: "header_datatable",
    sortable: true,
  },
  {
    text: "usuario",
    value: "usu_usuario",
    class: "header_datatable",
    sortable: true,
  },
  {
    text: "colegio",
    value: "nombre_colegio",
    class: "header_datatable",
    sortable: true,
  },
  {
    text: "administrador del sitio web inteligenio",
    value: "master_ck1_valor",
    align: "center",
    class: "header_datatable",
  },
  {
    text: "estado",
    value: "estado_usuario",
    align: "center",
    class: "header_datatable",
  },
  {
    text: "editar",
    value: "action_editar",
    sortable: false,
    align: "center",
    class: "header_datatable",
    width: "1",
  },
  {
    text: "borrar",
    value: "action_borrar",
    sortable: false,
    align: "center",
    class: "header_datatable",
    width: "1",
  },
];

export const GestionPerfilWebmasterheaders = [
  /* { text: 'ID', align: 'left', value: 'id', class:'secondary'}, */
  { text: "perfil", value: "descripcion_perfil", class: "header_datatable" },
  {
    text: "estado",
    value: "estadoValor",
    sortable: false,
    align: "center",
    class: "header_datatable",
  },
  {
    text: "editar",
    value: "action_editar",
    sortable: false,
    align: "center",
    class: "header_datatable",
    width: "1",
  },
  {
    text: "borrar",
    value: "action_borrar",
    sortable: false,
    align: "center",
    class: "header_datatable",
    width: "1",
  },
  {
    text: "configurar módulos",
    value: "action_config",
    sortable: false,
    align: "center",
    class: "header_datatable",
    width: "1",
  },
];

export const CurriculoNacionalHeaders = [
  /* { text: 'ID', align: 'left',  value: 'id', class:'secondary'}, */
  { text: "país", value: "nombre_pais", class: "header_datatable" },
  {
    text: "currículo nacional básico",
    value: "cod_curriculo",
    sortable: false,
    align: "center",
    class: "header_datatable",
  },
  {
    text: "observación",
    value: "observacion",
    sortable: false,
    align: "center",
    class: "header_datatable",
  },
  {
    text: "estado",
    value: "situacionValor",
    align: "center",
    class: "header_datatable",
  },
  {
    text: "editar",
    value: "action_editar",
    sortable: false,
    align: "center",
    class: "header_datatable",
    width: "1",
  },
  {
    text: "borrar",
    value: "action_borrar",
    sortable: false,
    align: "center",
    class: "header_datatable",
    width: "1",
  },
];

export const AgregarCompetenciaHeaders = [
  /* { text: 'ID', align: 'left',  value: 'id', class:'secondary'}, */
  { text: "competencias", value: "descripcion", class: "header_datatable" },
  {
    text: "editar",
    value: "action_editar",
    sortable: false,
    align: "center",
    class: "header_datatable",
    width: "1",
  },
  {
    text: "borrar",
    value: "action_borrar",
    sortable: false,
    align: "center",
    class: "header_datatable",
    width: "1",
  },
];

export const ConfigInicioheaders = [
  { text: "imagen", value: "filename", class: "header_datatable" },
  { text: "título del comunicado", value: "titulo", class: "header_datatable" },
  { text: "destinatario", value: "destinatario", class: "header_datatable" },
  { text: "fecha de inicio", value: "fecha_inicio", class: "header_datatable" },
  { text: "fecha de término", value: "fecha_fin", class: "header_datatable" },
  { text: "estado", value: "activo", class: "header_datatable" },
  {
    text: "editar",
    value: "action_editar",
    sortable: false,
    align: "center",
    class: "header_datatable",
    width: "1",
  },
];

export const ConfigEfemeridesHeaders = [
  { text: "imagen", value: "filename", class: "header_datatable" },
  { text: "título de la efeméride", value: "titulo", class: "header_datatable" },
  { text: "fecha de inicio", value: "fecha_inicio", class: "header_datatable" },
  { text: "fecha de término", value: "fecha_fin", class: "header_datatable" },
  { text: "estado", value: "activo", class: "header_datatable" },
  {
    text: "editar",
    value: "action_editar",
    sortable: false,
    align: "center",
    class: "header_datatable",
    width: "1",
  },
];



export const ConfigGradosWebmasterHeaders = [
  /*  { text: 'ID', align: 'left', sortable: false, value: 'id', class:'secondary'}, */
  { text: "grado", value: "desc_grado", class: "header_datatable" },
  {
    text: "nivel",
    value: "desc_nivel",
    class: "header_datatable",
    align: "center",
  },
  {
    text: "editar",
    value: "action_editar",
    sortable: false,
    align: "center",
    class: "header_datatable ",
    width: "1",
  },
  {
    text: "eliminar",
    value: "action_borrar",
    sortable: false,
    align: "center",
    class: "header_datatable ",
    width: "1",
  },
];

export const Gradosheaders = [
  {
    text: "país",
    value: "nombre_pais",
    class: "header_datatable",
    align: "center",
    sortable: false,
  },
  {
    text: "nivel",
    align: "center",
    value: "nivel",
    class: "header_datatable",
    sortable: false,
  },
  {
    text: "grado",
    value: "desc_grado",
    class: "header_datatable",
    align: "center",
    sortable: false,
  },
  {
    text: "editar",
    value: "action_editar",
    sortable: false,
    align: "center",
    class: "header_datatable",
    width: "1",
  },
  {
    text: "borrar",
    value: "action_borrar",
    sortable: false,
    align: "center",
    class: "header_datatable",
    width: "1",
  },
];

export const AnoelectivoHeaders = [
  /* { text: 'ID', align: 'left', value: 'id', class:'secondary'}, */
  {
    text: "nombre",
    value: "nom_anolectivo",
    class: "header_datatable",
  },
  {
    text: "fecha de inicio",
    value: "fecha_inicioFiltro",
    class: "header_datatable",
  },
  {
    text: "fecha de cierre",
    value: "fecha_cierreFiltro",
    class: "header_datatable",
  },
  {
    text: "estado",
    value: "estado",
    sortable: false,
    align: "center",
    class: "header_datatable",
  },
  {
    text: "editar",
    value: "action_editar",
    sortable: false,
    align: "center",
    class: "header_datatable",
  },
  {
    text: "eliminar",
    value: "action_eliminar",
    sortable: false,
    align: "center",
    class: "header_datatable",
    width: "1",
  },
];

export const PeriodosHeaders = [
  /* { text: 'ID', align: 'left', value: 'id', class:'secondary' }, */
  {
    text: "nombre del periodo",
    value: "nombre_periodo",
    class: "header_datatable",
    sortable: false,
    align: "center",
  },
  {
    text: "fecha de inicio",
    value: "fecha_inicioFiltro",
    class: "header_datatable",
    sortable: false,
    align: "center",
  },
  {
    text: "fecha de cierre",
    value: "fecha_cierreFiltro",
    class: "header_datatable",
    sortable: false,
    align: "center",
  },
  {
    text: "nivel",
    align: "center",
    value: "nivel",
    sortable: false,
    class: "header_datatable",
  },
  {
    text: "estado",
    align: "center",
    value: "status",
    sortable: false,
    class: "header_datatable",
  },
  {
    text: "editar",
    value: "action_editar",
    sortable: false,
    align: "center",
    class: "header_datatable",
  },
  {
    text: "eliminar",
    value: "action_eliminar",
    sortable: false,
    align: "center",
    class: "header_datatable",
    width: "1",
  },
];

export const EscalaEvaluacionHeaders = [
  { text: 'AÑO LECTIVO', value: 'nom_anolectivo', class: 'header_datatable' },
  { text: 'PERIODO', value: 'nombre_periodo', sortable: false, align: 'center', class: 'header_datatable' },
  { text: 'NIVEL', value: 'desc_nivel', sortable: false, align: 'center', class: 'header_datatable' },
  { text: 'ESTADO DE EVALUACIÓN', value: 'Estado', sortable: false, align: 'center', class: 'header_datatable' },
  { text: 'VER', value: 'action_ver', sortable: false, align: 'center', class: 'header_datatable ', width: '60' },
  { text: 'EDITAR', value: 'action_editar', sortable: false, align: 'center', class: 'header_datatable ', width: '60' },
  //{ text: 'ELIMINAR', value: 'action_borrar', sortable: false , align: 'center', class:'header_datatable px-0 mx-0', width:'1'},
];

export const NotaliteralHeaders = [
  /* { text: 'ID', align: 'left',  value: 'id', class:'secondary'}, */
  { text: 'NOTA', value: 'literal', class: 'header_datatable', align: 'center' },
  { text: 'EQUIVALENCIA NUMÉRICA MÍNIMA', value: 'nota_min', sortable: false, align: 'center', class: 'header_datatable' },
  { text: 'EQUIVALENCIA NUMÉRICA MÁXIMA', value: 'nota_max', sortable: false, align: 'center', class: 'header_datatable' },
  { text: 'INTERPRETACIÓN', value: 'interpretacion', sortable: false, align: 'center', class: 'header_datatable' },
  { text: 'DESCRIPCIÓN', value: 'Descripcion', sortable: false, align: 'center', class: 'header_datatable' },
  { text: 'AÑO LECTIVO', value: 'nom_anolectivo', sortable: false, align: 'center', class: 'header_datatable' },
  { text: 'EDITAR', value: 'action_editar', sortable: false, align: 'center', class: 'header_datatable ', width: '60' },
  { text: 'ELIMINAR', value: 'action_borrar', sortable: false, align: 'center', class: 'header_datatable', width: '60' },
];

export const NotanumericaHeaders = [
  /* { text: 'ID', align: 'left',  value: 'id', class:'secondary'}, */
  { text: 'NOTA MÍNIMA', value: 'nota_min', class: 'header_datatable' },
  { text: 'NOTA MÁXIMA', value: 'nota_max', sortable: false, align: 'center', class: 'header_datatable' },
  { text: 'NOTA MÍNIMA APROBATORIA', value: 'aprob_min', sortable: false, align: 'center', class: 'header_datatable' },
  { text: 'NOTA MÁXIMA APROBATORIA', value: 'aprob_max', sortable: false, align: 'center', class: 'header_datatable' },
  { text: 'AÑO LECTIVO', value: 'nom_anolectivo', sortable: false, align: 'center', class: 'header_datatable' },

  { text: 'EDITAR', value: 'action_editar', sortable: false, align: 'center', class: 'header_datatable ', width: '60' },
  { text: 'ELIMINAR', value: 'action_borrar', sortable: false, align: 'center', class: 'header_datatable ', width: '60' },
];




export const headersferiadosCalendario = [
  { text: 'Feriado Académico', value: 'name', class: "header_datatable" },
  { text: 'Detalle', value: 'details', class: "header_datatable" },
  { text: 'Fecha de inicio', value: 'start', class: "header_datatable" },
  { text: 'Fecha de cierre', value: 'end', class: "header_datatable" },
  { text: 'Editar', value: 'action_editar', sortable: false, class: "header_datatable" },
  { text: 'Eliminar', value: 'action_eliminar', sortable: false, class: "header_datatable" }
];

export const alumnsLibretaVirtHeaders = [
  {
    text: "alumno",
    value: "desc_alumno",
    class: "header_datatable",
  },
  {
    text: "nivel",
    value: "desc_nivel",
    class: "header_datatable",
  },
  {
    text: "Grado y Seccion",
    value: "desc_grado",
    class: "header_datatable",
  },
];

export const RegistropersonalHeaders = [
  /* { text: 'ID', align: 'left', value: 'id', class:'secondary'}, */
  {
    text: "n.° de documento de identidad",
    value: "numdoc_persona",
    class: "header_datatable",
  },
  {
    text: "apellidos y nombres",
    value: "apellido_nombre",
    class: "header_datatable",
  },
  {
    text: "correo electrónico",
    sortable: false,
    value: "correo_persona",
    class: "header_datatable",
  },
  {
    text: "tipo de personal",
    sortable: false,
    value: "desc_tipo_personal",
    class: "header_datatable",
  },
  {
    text: "docente",
    value: "profesorValor",
    sortable: false,
    align: "center",
    class: "header_datatable",
  },
  {
    text: "editar",
    value: "action_editar",
    sortable: false,
    align: "center",
    class: "header_datatable",
    width: "80",
  },
  {
    text: "estado",
    value: "estadoValor",
    sortable: false,
    align: "center",
    class: "header_datatable",
  },

  // {
  //   text: "eliminar",
  //   value: "action_borrar",
  //   sortable: false,
  //   align: "center",
  //   class: "header_datatable",
  //   width: "80",
  // },
];

export const RegistoAnecdoticoHeaders = [

  { text: "NIVEL", value: "nivel", class: "header_datatable" },
  { text: "GRADO", value: "grado", class: "header_datatable" },
  { text: "SECCIÓN", value: "seccion", class: "header_datatable" },
  { text: "APELLIDOS Y NOMBRES", value: "nombres", class: "header_datatable" },
  {
    groupable: true,

    text: "FECHA",
    value: "fecha",
    class: "header_datatable",
    align: "center",
  },
  {
    text: "HORA",
    value: "hora",
    align: "center",
    class: "header_datatable",
  },
  {
    text: "CONFIGURACIÓN DE REGISTRO ANECDÓTICO",
    value: "action",
    align: "center",
    width: '200',
    class: "header_datatable",
  },
];

export const headersTableAlumno = [
  {
    text: "n.° de documento de identidad",
    value: "persona.numdoc_persona",
    class: "header_datatable",
    sortable: true,
  },
  {
    text: "apellidos y nombres",
    value: "persona.fullnameAlumno",
    class: "header_datatable",
    sortable: true,
  },
  {
    text: "apoderado",
    value: "familiares[0].persona.fullnameFamiliar",
    class: "header_datatable",
    sortable: true,
  },
  {
    text: "estado",
    value: "estado_alumno",
    class: "header_datatable",
    sortable: true,
  },
  {
    text: "agregar",
    value: "agregar_miembros",
    class: "header_datatable",
    align: "center",
    sortable: false,
  },
  {
    text: "grupo familiar",
    value: "grupo_familiar",
    class: "header_datatable",
    align: "center",
    sortable: false,
  },
  {
    text: "editar",
    value: "editar_alumno",
    class: "header_datatable",
    align: "center",
    sortable: false,
  },
  {
    text: "ver",
    value: "ver_alumno",
    class: "header_datatable",
    align: "center",
    sortable: false,
  },
  {
    text: "eliminar",
    value: "eliminar_alumno",
    class: "header_datatable",
    align: "center",
    sortable: false,
  },
];

export const headersTableFamiliar = [
  {
    text: "n.° de documento de identidad",
    value: "familia.persona.numdoc_persona",
    class: "header_datatable",
  },
  {
    text: "apellidos y nombres",
    value: "familia.persona.fullnameFamiliar",
    class: "header_datatable",
  },
  {
    text: "parentesco",
    value: "parentesco.desc_tipos_parientes",
    class: "header_datatable",
  },
  {
    text: "apoderado",
    value: "apoderado",
    class: "header_datatable",
    align: "center",
    sortable: false,
  },
  {
    text: "estado",
    value: "estado",
    class: "header_datatable",
    align: "center",
    sortable: false,
  },
  {
    text: "editar",
    value: "editar_familiar",
    class: "header_datatable",
    align: "center",
    sortable: false,
  },
  {
    text: "ver datos",
    value: "ver_datos_familiar",
    class: "header_datatable",
    align: "center",
    sortable: false,
  },
  {
    text: "eliminar",
    value: "eliminar_familiar",
    class: "header_datatable",
    align: "center",
    sortable: false,
  },
];

export const PermisosUsiariosHeaders = [
  {
    text: "perfil",
    value: "descripcion_perfil",
    class: "header_datatable",
  },
  {
    text: "estado",
    value: "estadoValor",
    sortable: false,
    align: "center",
    class: "header_datatable",
  },
  {
    text: "editar",
    value: "action_editar",
    sortable: false,
    align: "center",
    class: "header_datatable ",
    width: "1",
  },
  {
    text: "Desactivar",
    value: "action_borrar",
    sortable: false,
    align: "center",
    class: "header_datatable ",
    width: "1",
  },
  {
    text: "configurar módulos",
    value: "action_config",
    sortable: false,
    align: "center",
    class: "header_datatable ",
    width: "1",
  },
];

export const SupervicionclasesDirectorHeaders = [
  { text: 'docente', value: 'nombre_apellido_docente', align: 'center', class: 'header_datatable' },
  { text: 'área', value: 'desc_area', align: 'center', class: 'header_datatable' },
  { text: 'nombre del tema', value: 'nombre_clase', align: 'center', class: 'header_datatable' },
  { text: 'fecha', value: 'fecha', align: 'center', class: 'header_datatable' },
  { text: 'hora de inicio', value: 'horaIn', sortable: false, align: 'center', class: 'header_datatable' },
  { text: 'hora de finalización', value: 'horaFin', sortable: false, align: 'center', class: 'header_datatable' },
  { text: 'estado', value: 'estado', sortable: false, align: 'center', class: 'header_datatable' },
  { text: 'clase', value: 'clase', sortable: false, align: 'center', class: 'header_datatable' },
  { text: 'clase virtual', value: 'claseVirtual', sortable: false, align: 'center', class: 'header_datatable' },
  { text: 'grabaciones', value: 'claseGrabada', sortable: false, align: 'center', class: 'header_datatable' },

  //{ text: '', value: 'action', sortable: false, align:'center', class:'header_datatable px-0 mx-0', width:'50'},
];

export const MallacurricularHeaders = [
  { text: 'NIVEL', value: 'desc_nivel', sortable: false, class: 'header_datatable', align: 'center' },
  { text: 'GRADO', value: 'desc_grado', sortable: false, class: 'header_datatable', align: 'center' },
  { text: 'ÁREA', value: 'desc_area', sortable: false, class: 'header_datatable', align: 'center' },
  { text: 'CURSO', value: 'desc_curso', sortable: false, class: 'header_datatable', align: 'center' },
  { text: 'UNIDAD', value: 'nombre_tema', sortable: false, class: 'header_datatable', align: 'center' },
  { text: 'TEMA', value: 'nombre_clase', sortable: false, class: 'header_datatable', align: 'center' },
  { text: 'LIBRO DE ACTIVIDADES DEL ESTUDIANTE', width: '1', value: 'action_cuaderno_estudiante', sortable: false, class: 'header_datatable', align: 'center' },
  { text: 'LIBRO DE ACTIVIDADES DEL DOCENTE', width: '1', value: 'action_cuaderno_docente', sortable: false, class: 'header_datatable', align: 'center' },
  { text: 'SESIÓN DE APRENDIZAJE', width: '1', value: 'action_sesion', sortable: false, class: 'header_datatable', align: 'center' },
  { text: 'VER CLASES', width: '1', value: 'action_clases', sortable: false, class: 'header_datatable', align: 'center' },
];

export const AlumnosExportheaders = [
  {
    text: "",
    value: "data-table-expand",
    class: "header_datatable",
    sortable: false,
  },
  {
    text: "Código del estudiante",
    value: "cod_estudiante",
    class: "header_datatable",
    sortable: false,
  },
  {
    text: "Nombres",
    value: "nombre_persona",
    class: "header_datatable",
    sortable: false,
  },
  {
    text: "Apellido paterno",
    value: "ape1_persona",
    class: "header_datatable",
    sortable: false,
  },
  {
    text: "Apellido materno",
    value: "ape2_persona",
    class: "header_datatable",
    sortable: false,
  },
  {
    text: "Tipo de documento",
    value: "tipo_documento",
    class: "header_datatable",
    sortable: false,
  },
  {
    text: "Número de documento de identidad",
    value: "numdoc_persona",
    class: "header_datatable",
    sortable: false,
  },
  {
    text: "Nivel escolar",
    value: "nivel",
    class: "header_datatable",
    sortable: false,
  },
  { text: "Grado", value: "grado", class: "header_datatable", sortable: false, },
  { text: "Sección", value: "seccion", class: "header_datatable", sortable: false, },
  {
    text: "Sexo",
    value: "sexo_persona",
    class: "header_datatable",
    sortable: false,
  },
  {
    text: "Fecha de nacimiento",
    value: "fecnac_refactored",
    class: "header_datatable",
    sortable: false,
  },
  {
    text: "País de nacimiento",
    value: "pais_nacimiento",
    class: "header_datatable",
    sortable: false,
  },
  {
    text: "Nacionalidad",
    value: "nacionalidad",
    class: "header_datatable",
    sortable: false,
  },
  {
    text: "Religión",
    value: "religion",
    class: "header_datatable",
    sortable: false,
  },
  {
    text: "Discapacidad",
    value: "discapacidad",
    class: "header_datatable",
    sortable: false,
  },
  {
    text: "Correo electrónico",
    value: "correo_persona",
    class: "header_datatable",
    sortable: false,
  },
  { text: "País", value: "pais", class: "header_datatable", sortable: false, },
  {
    text: "Departamento",
    value: "ubicacion1",
    class: "header_datatable",
    sortable: false,
  },
  {
    text: "Provincia",
    value: "ubicacion2",
    class: "header_datatable",
    sortable: false,
  },
  {
    text: "Distrito",
    value: "ubicacion3",
    class: "header_datatable",
    sortable: false,
  },
  {
    text: "Dirección",
    value: "direc_persona",
    class: "header_datatable",
    sortable: false,
  },
  {
    text: "Teléfono móvil",
    value: "cel_persona",
    class: "header_datatable",
    sortable: false,
  },
  {
    text: "Teléfono fijo",
    value: "telf_persona",
    class: "header_datatable",
    sortable: false,
  },
  {
    text: "Vive con",
    value: "viveCon",
    class: "header_datatable",
    sortable: false,
  },
];

export const PersonalExportHeaders = [
  {
    text: "",
    value: "data-table-expand",
    class: "header_datatable",
    sortable: false,
  },
  {
    text: "Nombres",
    value: "nombre_persona",
    class: "header_datatable",
    sortable: false,
  },
  {
    text: "Apellido paterno",
    value: "ape1_persona",
    class: "header_datatable",
    sortable: false,
  },
  {
    text: "Apellido materno",
    value: "ape2_persona",
    class: "header_datatable",
    sortable: false,
  },
  {
    text: "Tipo de documento",
    value: "tipo_documento",
    class: "header_datatable",
    sortable: false,
  },
  {
    text: "Número de documento de identidad",
    value: "numdoc_persona",
    class: "header_datatable",
    sortable: false,
  },
  {
    text: "Sexo",
    value: "sexo_persona",
    class: "header_datatable",
    sortable: false,
  },
  {
    text: "Fecha de nacimiento",
    value: "fecnac_refactored",
    class: "header_datatable",
    sortable: false,
  },
  {
    text: "País de nacimiento",
    value: "pais_nacimiento",
    class: "header_datatable",
    sortable: false,
  },
  {
    text: "Nacionalidad",
    value: "nacionalidad",
    class: "header_datatable",
    sortable: false,
  },
  {
    text: "Estado civil",
    value: "estado_civil",
    class: "header_datatable",
    sortable: false,
  },
  {
    text: "Discapacidad",
    value: "discapacidad",
    class: "header_datatable",
    sortable: false,
  },
  {
    text: "Tipo de personal",
    value: "tipo_personal",
    class: "header_datatable",
    sortable: false,
  },
  {
    text: "Fecha de ingreso",
    value: "fecingreso_refactored",
    class: "header_datatable",
    sortable: false,
  },
  { text: "País", value: "pais", class: "header_datatable", sortable: false, },
  {
    text: "Departamento",
    value: "ubicacion1",
    class: "header_datatable",
    sortable: false,
  },
  {
    text: "Provincia",
    value: "ubicacion2",
    class: "header_datatable",
    sortable: false,
  },
  {
    text: "Distrito",
    value: "ubicacion3",
    class: "header_datatable",
    sortable: false,
  },
  {
    text: "Código postal",
    value: "codigo_postal",
    class: "header_datatable",
    sortable: false,
  },
  {
    text: "Dirección",
    value: "direc_persona",
    class: "header_datatable",
    sortable: false,
  },
  {
    text: "Teléfono móvil",
    value: "cel_persona",
    class: "header_datatable",
    sortable: false,
  },
  {
    text: "Teléfono fijo",
    value: "telf_persona",
    class: "header_datatable",
    sortable: false,
  },
  {
    text: "Correo electrónico",
    value: "correo_persona",
    class: "header_datatable",
    sortable: false,

  },
  {
    text: "Perfil de usuario",
    value: "perfil_usuario",
    class: "header_datatable",
    sortable: false,

  },
];

export const FamiliaresExportHeaders = [
  {
    text: "",
    value: "data-table-expand",
    class: "header_datatable",
    sortable: false,
  },
  {
    text: "Nombre del estudiante",
    value: "nombre_alumno",
    class: "header_datatable ",
    sortable: false,
  },
  {
    text: "Apellido del estudiante",
    value: "ape1_alumno",
    class: "header_datatable ",
    sortable: false,
  },
  {
    text: "Tipo de documento del estudiante",
    value: "tipo_documento_alumno",
    class: "header_datatable ",
    sortable: false,
  },
  {
    text: "Número de documento del estudiante",
    value: "numdoc_alumno",
    class: "header_datatable ",
    sortable: false,
  },
  {
    text: "Parentesco",
    value: "parentesco",
    class: "header_datatable blue lighten-4 black--text",
    sortable: false,
  },

  {
    text: "Nombres",
    value: "nombre_persona",
    class: "header_datatable blue lighten-4 black--text",
    sortable: false,
  },
  {
    text: "Apellido paterno",
    value: "ape1_persona",
    class: "header_datatable blue lighten-4 black--text",
    sortable: false,
  },
  {
    text: "Apellido materno",
    value: "ape2_persona",
    class: "header_datatable blue lighten-4 black--text",
    sortable: false,
  },
  {
    text: "Tipo de documento",
    value: "tipo_documento",
    class: "header_datatable blue lighten-4 black--text",
    sortable: false,
  },
  {
    text: "Número de documento de identidad",
    value: "numdoc_persona",
    class: "header_datatable blue lighten-4 black--text",
    sortable: false,
  },
  {
    text: "Fecha de nacimiento",
    value: "fecnac_refactored",
    class: "header_datatable blue lighten-4 black--text",
    sortable: false,
  },
  {
    text: "País de nacimiento",
    value: "pais_nacimiento",
    class: "header_datatable blue lighten-4 black--text",
    sortable: false,
  },
  {
    text: "Nacionalidad",
    value: "nacionalidad",
    class: "header_datatable blue lighten-4 black--text",
    sortable: false,
  },
  {
    text: "Sexo",
    value: "sexo_persona",
    class: "header_datatable blue lighten-4 black--text",
    sortable: false,
  },
  {
    text: "Estado civil",
    value: "estado_civil",
    class: "header_datatable blue lighten-4 black--text",
    sortable: false,
  },
  { text: "País", value: "pais", class: "header_datatable blue lighten-4 black--text", sortable: false },
  {
    text: "Departamento",
    value: "ubicacion1",
    class: "header_datatable blue lighten-4 black--text",
    sortable: false,
  },
  {
    text: "Provincia",
    value: "ubicacion2",
    class: "header_datatable blue lighten-4 black--text",
    sortable: false,
  },
  {
    text: "Distrito",
    value: "ubicacion3",
    class: "header_datatable blue lighten-4 black--text",
    sortable: false,
  },
  {
    text: "Dirección",
    value: "direc_persona",
    class: "header_datatable blue lighten-4 black--text",
    sortable: false,
  },
  {
    text: "Teléfono móvil",
    value: "cel_persona",
    class: "header_datatable blue lighten-4 black--text",
    sortable: false,
  },
  {
    text: "Teléfono fijo",
    value: "telf_persona",
    class: "header_datatable blue lighten-4 black--text",
    sortable: false,
  },
  {
    text: "Correo electrónico",
    value: "correo_persona",
    class: "header_datatable blue lighten-4 black--text",
    sortable: false,
  },
  {
    text: "Profesión",
    value: "profesion",
    class: "header_datatable blue lighten-4 black--text",
    sortable: false,
  },
  {
    text: "Centro de trabajo",
    value: "centro_trabajo",
    class: "header_datatable blue lighten-4 black--text",
    sortable: false,
  },
  {
    text: "Teléfono de trabajo",
    value: "telefono_trabajo",
    class: "header_datatable blue lighten-4 black--text",
    sortable: false,
  },
  {
    text: "Dirección de trabajo",
    value: "direccion_trabajo",
    class: "header_datatable blue lighten-4 black--text",
    sortable: false,
  },
];

export const NotasExportHeaders = [
  {
    text: "",
    value: "data-table-expand",
    class: "header_datatable",
    sortable: false,
  },
  {
    text: "Nombres",
    value: "nombre_persona",
    class: "header_datatable",
    sortable: false,
  },
  {
    text: "Apellido paterno",
    value: "ape1_persona",
    class: "header_datatable",
    sortable: false,
  },
  {
    text: "Apellido materno",
    value: "ape2_persona",
    class: "header_datatable",
    sortable: false,
  },
  {
    text: "Tipo de documento",
    value: "tipo_documento",
    class: "header_datatable",
    sortable: false,
  },
  {
    text: "Número de documento de identidad",
    value: "numdoc_persona",
    class: "header_datatable",
    sortable: false,
  },
  { text: "Año", value: "anio", class: "header_datatable", sortable: false, },
  { text: "Área", value: "area", class: "header_datatable", sortable: false, },
  {
    text: "Competencia",
    value: "competencia",
    class: "header_datatable",
    sortable: false,
  },
  {
    text: "Tipo de nota",
    value: "tipo_de_nota",
    class: "header_datatable",
    sortable: false,
  },
  {
    text: "Nota 1er BIM",
    value: "nota_periodo1",
    class: "header_datatable",
    sortable: false,
  },
  {
    text: "Nota 2do BIM",
    value: "nota_periodo2",
    class: "header_datatable",
    sortable: false,
  },
  {
    text: "Nota 3er BIM",
    value: "nota_periodo3",
    class: "header_datatable",
    sortable: false,
  },
  {
    text: "Nota 4to BIM",
    value: "nota_periodo4",
    class: "header_datatable",
    sortable: false,
  },

];

export const NotasPasadasExportHeaders = [
  {
    text: "",
    value: "data-table-expand",
    class: "header_datatable",
    sortable: false,
  },
  {
    text: "Nombres",
    value: "nombre_persona",
    class: "header_datatable",
    sortable: false,
  },
  {
    text: "Apellido paterno",
    value: "ape1_persona",
    class: "header_datatable",
    sortable: false,
  },
  {
    text: "Apellido materno",
    value: "ape2_persona",
    class: "header_datatable",
    sortable: false,
  },
  {
    text: "Tipo de documento",
    value: "tipo_documento",
    class: "header_datatable",
    sortable: false,
  },
  {
    text: "Número de documento de identidad",
    value: "numdoc_persona",
    class: "header_datatable",
    sortable: false,
  },
  { text: "Año", value: "anio", class: "header_datatable", sortable: false, },
  { text: "Nivel", value: "nivel", class: "header_datatable", sortable: false, },
  { text: "Área", value: "area", class: "header_datatable", sortable: false, },
  { text: "Grado", value: "grado", class: "header_datatable", sortable: false, },
  { text: "Sección", value: "seccion", class: "header_datatable", sortable: false, },
  {
    text: "Competencia",
    value: "competencia",
    class: "header_datatable",
    sortable: false,
  },
  {
    text: "Tipo de nota",
    value: "tipo_de_nota",
    class: "header_datatable",
    sortable: false,
  },
  {
    text: "Nota 1er BIM",
    value: "nota_periodo1",
    class: "header_datatable",
    sortable: false,
  },
  {
    text: "Nota 2do BIM",
    value: "nota_periodo2",
    class: "header_datatable",
    sortable: false,
  },
  {
    text: "Nota 3er BIM",
    value: "nota_periodo3",
    class: "header_datatable",
    sortable: false,
  },
  {
    text: "Nota 4to BIM",
    value: "nota_periodo4",
    class: "header_datatable",
    sortable: false,
  },

];


export const ActividadesAlumnosHeadersheaders = [
  { text: 'docente', value: 'nombre_docente', class: 'header_datatable' },
  { text: 'curso', value: 'action_curso', class: 'header_datatable' },
  { text: 'unidad', value: 'nombre_tema', class: 'header_datatable' },
  { text: 'tema', value: 'nombre_clase', class: 'header_datatable' },
  { text: 'tipo de actividad', value: 'desc_tipo_actividad', class: 'header_datatable' },
  { text: 'fecha de entrega', value: 'action_fecha_actividad', class: 'header_datatable' },
  // { text: 'hora de entrega', value: 'hora_fin_actividad', class: 'header_datatable' },
  { text: 'calificación', value: 'calificacion_revision', class: 'header_datatable' },
  { text: 'estado', value: 'action_desc_estado_alumno', class: 'header_datatable' },
  { text: 'ficha tecnica', value: 'action_ver', sortable: false, align: 'center', class: 'header_datatable' },
  { text: 'descargar', value: 'action_descargar', sortable: false, align: 'center', class: 'header_datatable' },
  { text: 'cargar', value: 'action_cargar', sortable: false, align: 'center', class: 'header_datatable' },


];


export const SupervicionclasesCordinadoHeaders = [
  { text: 'docente', value: 'nombre_apellido_docente',align: 'center', class: 'header_datatable', sortable: false },
  { text: 'área', value: 'desc_area',align: 'center', class: 'header_datatable', sortable: false },
  { text: 'nombre del tema', sortable: false, value: 'nombre_clase', align: 'center', class: 'header_datatable' },
  { text: 'fecha', value: 'fecha', sortable: false, align: 'center', class: 'header_datatable' },
  { text: 'hora de inicio', value: 'horaIn', sortable: false, align: 'center', class: 'header_datatable' },
  { text: 'hora de finalización', value: 'horaFin', sortable: false, align: 'center', class: 'header_datatable' },
  { text: 'estado', value: 'estado', sortable: false, align: 'center', class: 'header_datatable' },
  { text: 'clase', value: 'clase', sortable: false, align: 'center', class: 'header_datatable' },
  { text: 'clase virtual', value: 'claseVirtual', sortable: false, align: 'center', class: 'header_datatable' },
  { text: 'grabaciones', value: 'claseGrabada', sortable: false, align: 'center', class: 'header_datatable' },

];

export const SupervisionEstudianteclasesHeaders = [
  { text: 'TEMA', align: 'center', value: 'nombre_clase', sortable: false, class: 'header_datatable' },
  { text: 'DOCENTE', value: 'nombre_apellido_docente', sortable: false, align: 'center', class: 'header_datatable' },
  { text: 'ACTIVIDAD ASIGNADA', value: 'tareaAsignada', sortable: false, align: 'center', class: 'header_datatable' },
  { text: 'FECHA DE ENTREGA', value: 'fechaEntrega', sortable: false, align: 'center', class: 'header_datatable' },
  { text: 'COMENTARIO DEL DOCENTE', value: 'comentarioDocente', sortable: false, align: 'center', class: 'header_datatable' },
  { text: 'CALIFICACIÓN', value: 'calificacion', sortable: false, align: 'center', class: 'header_datatable' },
  { text: 'ESTADO', value: 'estadoTarea', sortable: false, align: 'center', class: 'header_datatable' },
  { text: 'ACTIVIDAD ENVIADA', value: 'tareaEnviada', sortable: false, align: 'center', class: 'blue lighten-4 black--text' },
  { text: 'FECHA DE ENVÍO', value: 'fechaEnvio', sortable: false, align: 'center', class: 'blue lighten-4 black--text' },
  { text: 'COMENTARIO DEL ESTUDIANTE', value: 'comentarioAlumno', sortable: false, align: 'center', class: 'blue lighten-4 black--text' },

];

export const GestionContenidoVisorTemasHeaders = [
  {
    text: "TEMAS",
    value: "nombre_clase",
    class: "header_datatable",
  },
  { text: "ORDEN", value: "orden_clase", class: "header_datatable" },
  {
    text: "EDITAR TEMA",
    value: "edit",
    sortable: false,
    align: "center",
    class: "header_datatable",
    width: "100",
  },
  {
    text: "VER DIAPOSITIVAS",
    value: "view",
    sortable: false,
    align: "center",
    class: "header_datatable",
    width: "100",
  },
  {
    text: "CREAR DIAPOSITIVAS",
    value: "view_diapo",
    sortable: false,
    align: "center",
    class: "header_datatable ",
    width: "100",
  },
  {
    text: "CREAR PREGUNTAS",
    value: "view_somos_habiles",
    sortable: false,
    align: "center",
    class: "header_datatable ",
    width: "100",
  },

  {
    text: "LIBRO DE ACTIVIDADES",
    value: "cuaderno",
    sortable: false,
    align: "center",
    class: "header_datatable ",
    width: "100",
  },
  {
    text: "SESIÓN DE APRENDIZAJE",
    value: "session_a",
    sortable: false,
    align: "center",
    class: "header_datatable ",
    width: "100",
  },
  {
    text: "eliminar",
    value: "delete",
    sortable: false,
    align: "center",
    class: "header_datatable ",
    width: "1",
  },
];

export const Postulantesheaders = [
  {
    text: "APELLIDOS Y NOMBRES",
    value: "apellidos_nombres_familiar",
    sortable: false,
    class: "header_datatable",
  },
  {
    text: "MÓVIL",
    value: "familiar.cel_familiar",
    sortable: false,
    class: "header_datatable",
  },
  {
    text: "CORREO ELECTRÓNICO",
    value: "familiar.correo_familiar",
    sortable: false,
    class: "header_datatable",
  },
  {
    text: "DNI",
    value: "numdoc_postulante",
    sortable: false,
    class: "header_datatable",
  },
  {
    text: "APELLIDOS Y NOMBRES",
    value: "apellidos_nombres_postulante",
    sortable: false,
    class: "header_datatable",
  },
  {
    text: "NIVEL",
    value: "condicion.nivel.desc_nivel",
    sortable: false,
    class: "header_datatable",
  },
  {
    text: "GRADO",
    value: "grado.grado.desc_grado",
    sortable: false,
    class: "header_datatable",
  },
  {
    text: "FECHA DE ENTREVISTA",
    value: "fecha_entrevista",
    sortable: false,
    class: "header_datatable",
  },
  {
    text: "ESTADO",
    value: "id_estado_postulante",
    sortable: false,
    class: "header_datatable",
  },
  {
    text: "ACCIONES",
    align: "center",
    value: "action",
    sortable: false,
    class: "header_datatable",
  },
];

export const RelacionpostulantesHeaders = [

  {
    text: "NOMBRES",
    value: "nombre_familiar",
    class: "header_datatable",
    sortable: false,
  },
  {
    text: "APELLIDOS PATERNO",
    value: "ape1_familiar",
    class: "header_datatable",
    sortable: false,
  },
  {
    text: "MOVIL",
    value: "cel_familiar",
    class: "header_datatable",
    sortable: false,
  },
  {
    text: "CORREO ELECTRÓNICO",
    value: "correo_familiar",
    class: "header_datatable",
    sortable: false,
  },
  {
    text: "DNI",
    value: "numdoc_postulante",
    class: "header_datatable",
    sortable: false,
  },
  {
    text: "NOMBRES",
    value: "nombre_postulante",
    class: "header_datatable",
    sortable: false,
  },
  {
    text: "APELLIDOS PATERNO",
    value: "ape1_postulante",
    class: "header_datatable",
    sortable: false,
  },
  {
    text: "NIVEL",
    value: "desc_nivel",
    class: "header_datatable",
    sortable: false,
  },
  {
    text: "GRADO",
    value: "desc_grado",
    class: "header_datatable",
    sortable: false,
  },
  {
    text: "FECHA DE ENTREVISTA",
    value: "fecha_entrevista2",
    class: "header_datatable",
    sortable: false,
  },
  {
    text: "FECHA DE RECHAZO",
    value: "fecha_rechazo_postulacion",
    class: "header_datatable",
    sortable: false,
  },
];


export const ListdiapositivaHeaders = [
  {
    text: "TIPO DE DIAPOSITIVA",
    value: "tipo",
    class: "header_datatable",
  },
  { text: "ORDEN", value: "orden", class: "header_datatable" },
  {
    text: "FECHA DE CREACIÓN",
    value: "fecha",
    class: "header_datatable",
  },
  {
    text: "EDITAR",
    value: "edit",
    sortable: false,
    align: "center",
    class: "header_datatable",
    width: "100",
  },
  {
    text: "BORRAR",
    value: "delete",
    sortable: false,
    align: "center",
    class: "header_datatable",
    width: "1",
  },

];

export const GestionContenidosHeadersTema = [
  {
    text: "UNIDAD",
    value: "nombre_tema",
    class: "header_datatable",
  },
  { text: "ORDEN", value: "orden", class: "header_datatable" },

  // { text: 'CUADERNO DE TRABAJO', value:'cuaderno', align: 'center', class:'header_datatable'},

  {
    text: "ver",
    value: "action_crear_clase",
    sortable: false,
    align: "center",
    class: "header_datatable ",
  },
  {
    text: "EDITAR",
    value: "action_editar",
    sortable: false,
    align: "center",
    class: "header_datatable ",
  },
  {
    text: "ELIMINAR",
    value: "action_borrar",
    sortable: false,
    align: "center",
    class: "header_datatable ",
  },
];


export const CriteriosconductasHeaders = [
  {
    text: "N.° DE CRITERIO",
    sortable: false,
    value: "numero",
    class: "header_datatable",
  },
  {
    text: "NOMBRE DEL CRITERIO",
    value: "nombre",
    class: "header_datatable",
  },
  {
    text: "NIVEL",
    value: "desc_nivel",
    class: "header_datatable",
  },
  {
    text: "INDICADOR",
    value: "indicador",
    class: "header_datatable",
  },
  { text: "EDITAR", value: "editar", class: "header_datatable" },
  { text: "ELIMINAR", value: "eliminar", class: "header_datatable" },
];

export const Papeletaheaders = [
  {
    text: "TIPO DE PAPELETA",
    value: "tipo_papeleta",
    class: "header_datatable",
  },
  {
    text: "INCIDENCIAS",
    value: "tipo_incidencia.descripcion",
    class: "header_datatable",
  },
  { text: "PUNTAJE", value: "puntaje", class: "header_datatable" },
  { text: "EDITAR", value: "editar", class: "header_datatable" },
  { text: "ELIMINAR", value: "eliminar", class: "header_datatable" },
];

export const IncidenciaManualHeaders = [
  {
    text: "N.° DE INCIDENCIAS",
    value: "numero",
    class: "header_datatable",
  },
  {
    text: "INCIDENCIAS",
    value: "tipo_incidencia.descripcion",
    class: "header_datatable",
  },
  {
    text: "NIVEL DE INCIDENCIA",
    value: "nivel_incidencia",
    class: "header_datatable",
  },
  {
    text: "DESCRIPCIÓN",
    value: "descripcion",
    class: "header_datatable",
  },
  { text: "EDITAR", value: "editar", class: "header_datatable" },
  { text: "ELIMINAR", value: "eliminar", class: "header_datatable" },
];


export const headersMuestraExamenes = [
  {
    text: "RESULTADOS",
    value: "accion_opciones",
    class: "header_datatable",
  },
  { text: "CÓDIGO", value: "codigo", class: "header_datatable" },
  {
    text: "ESTUDIANTE",
    value: "idusuario",
    class: "header_datatable",
  },
  {
    text: "AUTOR",
    value: "descripcion",
    class: "header_datatable",
  },
  {
    text: "INICIO",
    value: "fecha_inicio",
    class: "header_datatable",
  },
  {
    text: "FIN",
    value: "fecha_fin",
    class: "header_datatable",
  },
  {
    text: "ESTADO",
    value: "estado",
    sortable: false,
    class: "header_datatable shrink-column_estado",
  },
];

export const ProgramacionDocenteHeader = [
  {
    text: "GRADO",
    value: "desc_grado",
    align: "center",
    class: "header_datatable",
  },
  {
    text: "SECCIÓN",
    value: "nombre_seccion",
    class: "header_datatable",
    align: "center",
  },
  {
    text: "UNIDAD",
    value: "nombre_tema",
    class: "header_datatable",
    align: "center",
  },
  {
    text: "TEMA",
    value: "nombre_clase",
    class: "header_datatable",
    align: "center",
  },
  {
    text: "FECHA",
    value: "fecha",
    class: "header_datatable",
    align: "center",
  },
  {
    text: "HORA DE INICIO",
    value: "hora_inicio",
    class: "header_datatable",
    align: "center",
  },
  {
    text: "HORA DE FINALIZACIÓN",
    value: "hora_fin",
    align: "center",
    class: "header_datatable",
  },
  {
    text: "ESTADO",
    value: "desc_estado",
    align: "center",
    class: "header_datatable ",
  },
  {
    text: "ASIGNAR ACTIVIDAD",
    value: "asig_prog",
    class: "header_datatable",
    align: "center",
  },
  {
    text: "ASISTENCIA DE CLASE",
    value: "asist_prog",
    class: "header_datatable",
    align: "center",
  },
  {
    text: "SEGUIMIENTO",
    value: "segui_prog",
    class: "header_datatable",
    align: "center",
  },
  {
    text: "ACCIONES",
    value: "acc_prog",
    align: "center",
    class: "header_datatable",
  },
  // {
  //   text: "EDICION",
  //   value: "edic_prog",
  //   align: "center",
  //   class: "header_datatable",
  // },
];

export const ListAsistenciaHeaders = [
  {
    text: "N.° DE DOCUMENTO DE IDENTIDAD",
    value: "numdoc_alumno",
    align: "center",
    class: "header_datatable",
  },
  {
    text: "APELLIDOS Y NOMBRES",
    value: "ap_nombre",
    class: "header_datatable",
    align: "center",
    sortable: false,
  },
  {
    text: "OBSERVACIÓN",
    value: "observacion_asistencia",
    class: "header_datatable",
    align: "center",
    sortable: false,
  },
  {
    text: "ESTADO",
    value: "id_estado_asistencia",
    class: "header_datatable",
    align: "center",
    sortable: false,
  },
  {
    text: "CARGAR DOCUMENTO",
    value: "cargar_documento",
    class: "header_datatable",
    align: "center",
    sortable: false,
  },
  {
    text: "DESCARGAR DOCUMENTO",
    value: "descargar_documento",
    class: "header_datatable",
    align: "center",
    sortable: false,
  },
];

export const ActividadesDocenteHeader = [
  {
    text: "NIVEL",
    align: "center",
    value: "desc_nivel",
    sortable: false,
    class: "header_datatable",
  },
  {
    text: "GRADO",
    align: "center",
    value: "desc_grado",
    sortable: false,
    class: "header_datatable",
  },
  {
    text: "SECCION",
    value: "nombre_seccion",
    align: "center",
    sortable: false,
    class: "header_datatable",
  },
  {
    text: "CURSO",
    value: "desc_curso",
    align: "center",
    sortable: false,
    class: "header_datatable",
  },
  {
    text: "UNIDAD",
    value: "nombre_tema",
    align: "center",
    sortable: false,
    class: "header_datatable",
  },
  {
    text: "TEMA",
    value: "nombre_clase",
    align: "center",
    sortable: false,
    class: "header_datatable",
  },
  {
    text: "ACTIVIDAD",
    value: "desc_tipo_actividad",
    align: "center",
    sortable: false,
    class: "header_datatable",
  },
  {
    text: "CREADA",
    value: "fec_us_ing_actividad",
    align: "center",
    sortable: false,
    class: "header_datatable",
  },
  {
    text: "FECHA DE ENTREGA",
    value: "fecha_actividad",
    align: "center",
    sortable: false,
    class: "header_datatable",
  },
  {
    text: "HORA DE ENTREGA",
    value: "hora_fin_actividad",
    align: "center",
    sortable: false,
    class: "header_datatable",
  },
  {
    text: "EDITAR",
    value: "editar_actividad",
    align: "center",
    sortable: false,
    class: "header_datatable",
  },
  {
    text: "EVALUAR",
    value: "evaluar_actividad",
    align: "center",
    sortable: false,
    class: "header_datatable",
  },
];

export const EvaluaractividadHeaders = [

  {
    text: "N.° de DOCUMENTO DE IDENTIDAD",
    value: "numdoc_alumno",
    class: "header_datatable",
  },
  {
    text: "APELLIDOS Y NOMBRES",
    value: "apellido_nombre",
    class: "header_datatable",
  },
  {
    text: "OBSERVACIÓN DEL ESTUDIANTE",
    value: "observacion_alumno",
    class: "header_datatable",
  },
  {
    text: "DESCARGAR ACTIVIDAD",
    value: "action_descargar",
    sortable: false,
    align: "center",
    class: "header_datatable px-0 mx-0",
    width: "1",
  },

  {
    text: "CALIFICACIÓN",
    value: "calificacion",
    class: "header_datatable",
  },
  {
    text: "OBSERVACIÓN DE LA ACTIVIDAD",
    value: "observacion",
    class: "header_datatable",
  },
  { text: "ESTADO", value: "estadoValor", class: "header_datatable" },
];




export const ActividadesAlumnosHeaders = [
  {
    text: "N.° DOCUMENTO DE IDENTIDAD",
    value: "numdoc_alumno",
    class: "header_datatable",
  },
  {
    text: "APELLIDOS Y NOMBRES",
    value: "apellido_nombre",
    class: "header_datatable",
  },
  {
    text: "OBSERVACIÓN DEL ESTUDIANTE",
    value: "observacion_alumno",
    class: "header_datatable",
  },
  {
    text: "DESCARGAR ACTIVIDAD",
    value: "action_descargar",
    sortable: false,
    align: "center",
    class: "header_datatable",
  },

  {
    text: "CALIFICACIÓN",
    value: "calificacion",
    class: "header_datatable",
  },
  {
    text: "OBSERVACIÓN DE LA EVALUACIÓN",
    value: "observacion",
    class: "header_datatable",
  },
  { text: "ESTADO", value: "estadoValor", class: "header_datatable" },
];

export const ProgDocenteHeader = [
  {
    text: "DOCENTE",
    align: "center",
    value: "nombre_apellido_doc",
    sortable: false,
    class: "header_datatable",
  },
  {
    text: "CURSO",
    align: "center",
    value: "desc_curso",
    sortable: false,
    class: "header_datatable",
  },
  {
    text: "UNIDAD",
    align: "center",
    value: "nombre_tema",
    sortable: false,
    class: "header_datatable",
  },
  {
    text: "TEMA",
    align: "center",
    value: "nombre_clase",
    sortable: false,
    class: "header_datatable",
  },
  {
    text: "FECHA",
    align: "center",
    value: "fecha",
    sortable: false,
    class: "header_datatable",
  },
  {
    text: "HORA DE INICIO",
    value: "hora_inicio",
    align: "center",
    sortable: false,
    class: "header_datatable",
  },
  {
    text: "HORA DE FIN",
    value: "hora_fin",
    align: "center",
    sortable: false,
    class: "header_datatable",
  },
  {
    text: "ESTADO",
    value: "desc_estado",
    align: "center",
    sortable: false,
    class: "header_datatable",
  },
  {
    text: "VER CLASE",
    value: "ver_clase",
    align: "center",
    sortable: false,
    class: "header_datatable",
  },
  {
    text: "INGRESAR A LA CLASE VIRTUAL",
    value: "ing_clase_virt",
    align: "center",
    sortable: false,
    class: "header_datatable",
  },
  {
    text: "GRABACIONES",
    value: "grabac_clase",
    align: "center",
    sortable: false,
    class: "header_datatable",
  },
];

export const MisevaluacionesAlumHeaders = [
  { text: 'DOCENTE', value: 'profesor', class: 'header_datatable', sortable: false },
  { text: 'CURSO', value: 'desc_curso', class: 'header_datatable', sortable: false, align: 'center' },
  { text: 'EVALUACIÓN', value: 'nombre_evaluacion', align: 'center', class: 'header_datatable', sortable: false },
  { text: 'FORMA', value: 'desc_forma', class: 'header_datatable', sortable: false },
  { text: 'TIPO', value: 'desc_tipo', class: 'header_datatable', sortable: false },
  { text: 'FECHA PROGRAMADA', value: 'fecha', align: 'center', class: 'header_datatable', sortable: false },
  { text: 'HORA DE INICIO', value: 'action_hora', align: 'center', class: 'header_datatable', sortable: false },
  { text: 'ESTADO', value: 'id_estado_evaluacion', align: 'center', class: 'header_datatable', sortable: false },
  { text: 'REALIZAR', value: 'action_evaluar', sortable: false, align: 'center', class: 'header_datatable', width: '80' },
  { text: 'VISUALIZAR', value: 'action_ver', sortable: false, align: 'center', class: 'header_datatable', width: '80' },
  { text: 'NOTA', value: 'action_nota', sortable: false, align: 'center', class: 'header_datatable', width: '80' }

];

export const MisclasesAlumnoHeader = [
  {
    text: "DOCENTE",
    align: "center",
    value: "nombre_apellido_doc",
    sortable: false,
    class: "header_datatable",
  },
  {
    text: "CURSO",
    align: "center",
    value: "desc_curso",
    sortable: false,
    class: "header_datatable",
  },
  {
    text: "UNIDAD",
    align: "center",
    value: "nombre_tema",
    sortable: false,
    class: "header_datatable",
  },
  {
    text: "TEMA",
    align: "center",
    value: "nombre_clase",
    sortable: false,
    class: "header_datatable",
  },
  {
    text: "FECHA",
    align: "center",
    value: "fecha",
    sortable: false,
    class: "header_datatable",
  },
  {
    text: "HORA DE INICIO",
    value: "hora_inicio",
    align: "center",
    sortable: false,
    class: "header_datatable",
  },
  {
    text: "HORA DE FINALIZACIÓN",
    value: "hora_fin",
    align: "center",
    sortable: false,
    class: "header_datatable",
  },
  {
    text: "ESTADO",
    value: "desc_estado",
    align: "center",
    sortable: false,
    class: "header_datatable",
  },
  {
    text: "Somos hábiles",
    value: "somos_habiles",
    align: "center",
    sortable: false,
    class: "header_datatable",
  },
  {
    text: "VER CLASE",
    value: "ver_clase",
    align: "center",
    sortable: false,
    class: "header_datatable",
  },
  {
    text: "INGRESAR A LA CLASE VIRTUAL",
    value: "ing_clase_virt",
    align: "center",
    sortable: false,
    class: "header_datatable",
  },
  {
    text: "GRABACIONES",
    value: "grabac_clase",
    align: "center",
    sortable: false,
    class: "header_datatable",
  },
];

export const ClasesdelEstudiante = [
  {
    text: "Docente",
    value: "nombre_apellido_docente",
    sortable: false,
    class: "header_datatable",
  },
  {
    text: "curso",
    value: "desc_curso",
    class: "header_datatable",
    sortable: false,
  },
  {
    text: "Unidad",
    value: "nombre_tema",
    class: "header_datatable",
    sortable: false,
  },

  {
    text: "Tema",
    value: "nombre_clase",
    class: "header_datatable",
    sortable: false,
  },
  {
    text: "Fecha",
    value: "fecha",
    class: "header_datatable",
    sortable: false,
  },
  {
    text: "Hora de Inicio",
    value: "horaIn",
    sortable: false,
    class: "header_datatable",
  },
  {
    text: "Hora de Finalización",
    value: "horaFin",
    sortable: false,
    class: "header_datatable",
  },
  {
    text: "Asistencia",
    value: "asistencia",
    align: "center",
    sortable: false,
    class: "header_datatable",
  },
  {
    text: "Justificaciones",
    value: "archivoAsistencia",
    sortable: false,
    align: "center",
    class: "header_datatable",
  },
  {
    text: "Comentario",
    value: "comentarioAsistencia",
    sortable: false,
    align: "center",
    class: "header_datatable",
  },
];

export const ActividadesEstudiante = [
  {
    text: "Tema",
    value: "nombre_clase",
    class: "header_datatable",
    sortable: false,
  },
  {
    text: "Actividad Asignada",
    sortable: false,
    value: "tareaAsignada",
    class: "header_datatable",
  },
  {
    text: "Calificación",
    value: "calificacion",
    sortable: false,
    align: "center",
    class: "header_datatable",
  },
  {
    text: "Fecha de entrega",
    sortable: false,
    value: "fechaTope",
    class: "header_datatable",
  },
  {
    text: "Objetivo de la Actividad",
    sortable: false,
    value: "comentarioDoc",
    class: "header_datatable",
  },
  // { text: 'CALIFICACIÓN ', value: 'calificacion', sortable: false,  class:'header_datatable'},
  {
    text: "Estado",
    value: "estado",
    sortable: false,
    class: "header_datatable",
  },
  {
    text: "Actividad Enviada",
    value: "tareaEnviada",
    sortable: false,
    align: "center",
    class: "info white--text",
  },
  {
    text: "Fecha de Envío",
    value: "fechaEnviada",
    sortable: false,
    align: "center",
    class: "info white--text",
  },
  {
    text: "Estado de la Actividad",
    value: "estado_alumno",
    sortable: false,
    align: "center",
    class: "info white--text",
  },
  {
    text: "Observaciones de la Actividad",
    value: "comentarioAlum",
    sortable: false,
    align: "center",
    class: "info white--text",
  },
];

export const SeccionHeaders = [
  { text: "grado", value: "desc_grado", class: "header_datatable" },
  { text: "opciones", align: "center", value: "agregar", sortable: false, class: "header_datatable" }

];

export const SeccionesHeaders = [

  { text: "sección", value: "nombre_seccion", align: 'center', class: "header_datatable" },
  { text: "capacidad mínima", value: "min_capacidad", align: 'center', class: "header_datatable" },
  { text: "capacidad máxima", value: "max_capacidad", align: 'center', class: "header_datatable" },
  { text: "acciones", value: "agregar", align: 'center', sortable: false, class: "header_datatable" }

];

export const ProgramarEvaluacionHeaders = [
  { text: 'grado', value: 'desc_grado', class: 'header_datatable' },
  { text: 'unidad', value: 'nombre_tema', align: 'center', class: 'header_datatable' },
  { text: 'tema', value: 'nombre_clase', align: 'center', class: 'header_datatable' },
  { text: 'fecha', value: 'fecha', align: 'center', class: 'header_datatable' },
  { text: 'estado', value: 'desc_estado', align: 'center', class: 'header_datatable' },
  { text: 'periodo', value: 'nombre_periodo', align: 'center', class: 'header_datatable' },
  { text: 'seleccionar', value: 'action_programar', class: 'header_datatable' },
  { text: 'ver', value: 'action_ver', sortable: false, align: 'center', class: 'header_datatable', width: '1' },
  // { text: 'editar', value: 'action_editar', sortable: false, align: 'center', class: 'header_datatable', width: '1' },
  // { text: 'Eliminar', value: 'action_borrar', sortable: false, align: 'center', class: 'header_datatable', width: '1' },

];

export const InteligenioProgHeadersClases = [
  { text: "GRADO", value: "desc_grado", class: "header_datatable", align: "center", },
  { text: "UNIDAD", value: "nombre_tema", class: "header_datatable", align: "center", },
  { text: "TEMA", value: "nombre_clase", class: "header_datatable", align: "center", },
  {
    text: "FECHA DE CREACIÓN",
    value: "fecha_ingreso",
    sortable: false,
    class: "header_datatable",
    align: "center",
  },
  {
    text: "ESTADO SECCION",
    value: "estadoValor",
    sortable: false,
    align: "center",
    class: "header_datatable",
  },
  { text: "PROGRAMAR", value: "programar", class: "header_datatable", sortable: false, align: "center", },
  {
    text: "VER CLASE",
    value: "action_ver",
    sortable: false,
    align: "center",
    class: "header_datatable",
    width: "1",
  },
];

export const ColegioProgHeadersClases = [
  { text: "GRADO", value: "desc_grado", class: "header_datatable", align: "center", },
  { text: "UNIDAD", value: "nombre_tema", class: "header_datatable", align: "center", },
  { text: "TEMA", value: "nombre_clase", class: "header_datatable", align: "center", },
  {
    text: "FECHA DE CREACIÓN",
    value: "fechaCreacion",
    sortable: false,
    class: "header_datatable",
    align: "center",
  },
  {
    text: "ESTADO SECCION",
    value: "estadoValor",
    sortable: false,
    class: "header_datatable",
    align: "center",
  },
  { text: "PROGRAMAR", value: "programar", class: "header_datatable", align: "center", },
  {
    text: "VER CLASE",
    value: "action_ver",
    sortable: false,
    align: "center",
    class: "header_datatable",
    width: "1",
  },
];

export const salonHeaders = [
  /* { text: "#", align: "left", sortable: false, value: "id" }, */
  { text: "n.° documento de identidad", value: "numdoc_persona", class: "header_datatable" },
  { text: "apellidos y nombres", align: "center", value: "nom_alumno", sortable: false, class: "header_datatable" },
  { text: "sexo", align: 'center', value: "sexo", sortable: false, class: "header_datatable" },
  { text: "eliminar", value: 'action_eliminar', sortable: false, align: "center", class: "header_datatable", width: "1" },
];

export const tablaAlumnosHeaders = [
  /* { text: "#", align: "left", sortable: false, value: "id_persona" }, */
  { text: "n.° de documento de identidad", align: 'center', value: "numdoc_persona", class: "header_datatable" },
  { text: "apellidos y nombres", align: 'center', value: "nom_alumno", class: "header_datatable" },
  { text: "fecha de nacimiento", align: 'center', value: "fecnac_persona", class: "header_datatable" },
  { text: "sexo", align: 'center', value: "sexo", class: "header_datatable" },
];

export const supervisionDocenteDirector = [
  /* { text: "#", align: "left", sortable: false, value: "id_persona" }, */
  { text: "grado", sortable: false, align: 'center', value: "desc_grado", class: "header_datatable" },
  { text: "sección", sortable: false, align: 'center', value: "nombre_seccion", class: "header_datatable" },
  // { text: "área", sortable: false, align: 'center', value: "desc_area", class: "header_datatable" },
  { text: "curso", sortable: false, align: 'center', value: "curso_desc", class: "header_datatable" },
  { text: "tema", sortable: false, align: 'center', value: "nombre_clase", class: "header_datatable" },
  { text: "fecha", sortable: false, align: 'center', value: "fecha", class: "header_datatable" },
  { text: "hora de inicio", sortable: false, align: 'center', value: "hora_inicio", class: "header_datatable" },
  { text: "hora de finalización", sortable: false, align: 'center', value: "hora_fin", class: "header_datatable" },
  { text: "estado", sortable: false, align: 'center', value: "id_estado", class: "header_datatable" },
  { text: "ver clase", sortable: false, align: 'center', value: "id_clase", class: "header_datatable" },
  { text: "seguimiento", sortable: false, align: 'center', value: "seguimiento_val", class: "header_datatable" },
  { text: "sesión de aprendizaje", sortable: false, align: 'center', value: "sesion_val", class: "header_datatable" },
  { text: "clase virtual", sortable: false, align: 'center', value: "clasv_val", class: "header_datatable" },
  { text: "grabaciones", sortable: false, align: 'center', value: "grabcion_val", class: "header_datatable" },

];



export const coordinacionHeaders = [
  { text: 'coordinación', align: 'center', value: 'nombre_coordinacion', class: 'header_datatable' },
  { text: 'ámbito', align: 'center', value: 'ambito', class: 'header_datatable' },
  { text: 'responsable', align: 'center', value: 'respon', class: 'header_datatable' },
  { text: 'n.° de documento de identidad', align: 'center', value: 'numdoc_persona', class: 'header_datatable' },
  { text: 'tipo', align: 'center', value: 'Tipo', class: 'header_datatable' },
  { text: 'acciones', align: 'center', value: 'accion', class: 'header_datatable' },
];

export const AsignacionCursosHeaders = [
  /* { text: "#", align: "left", sortable: false, value: "id" }, */
  {
    text: "sección",
    value: "nombre_seccion",
    class: "header_datatable",
  },
  {
    text: "turno",
    value: "ck1_mant_turno.desc_turno",
    class: "header_datatable",
  },
  {
    text: "capacidad mínima",
    value: "min_capacidad",
    class: "header_datatable",
  },
  {
    text: "capacidad máxima",
    value: "max_capacidad",
    class: "header_datatable",
  },
  {
    text: "opciones",
    value: "action",
    sortable: false,
    class: "header_datatable",
  }
];

export const ConfigCurriculoNacionalHeaders = [
  /* { text: 'ID', align: 'left',  value: 'id', class:'secondary'}, */
  { text: 'año lectivo', value: 'nom_anolectivo', class: 'header_datatable' },
  { text: 'currículo nacional', value: 'nombre_curriculo', sortable: false, align: 'center', class: 'header_datatable' },
  { text: 'observación', value: 'observacion', sortable: false, align: 'center', class: 'header_datatable' },
  { text: 'estado ', value: 'situacionValor', align: 'center', class: 'header_datatable' },
  { text: 'editar ', value: 'action_editar', sortable: false, align: 'center', class: 'header_datatable', width: '1' },
];

export const GestionarEvaluacionHeaders = [
  { text: 'curso', value: 'desc_curso', sortable: false, class: 'header_datatable' },
  { text: 'grado', value: 'desc_grado', sortable: false, class: 'header_datatable' },
  { text: 'sección', value: 'nombre_seccion', sortable: false, class: 'header_datatable' },
  { text: 'descripcion', value: 'nombre_evaluacion', align: 'center', sortable: false, class: 'header_datatable' },
  { text: 'forma', value: 'desc_forma', align: 'center', sortable: false, class: 'header_datatable' },
  { text: 'tipo', value: 'desc_tipo', align: 'center', sortable: false, class: 'header_datatable' },
  { text: 'fecha', value: 'fecha', align: 'center', sortable: false, class: 'header_datatable' },
  { text: 'hora de inicio - hora de FINALIZACIÓN', value: 'action_hora', align: 'center', sortable: false, class: 'header_datatable', width: '200' },
  { text: 'estado', value: 'id_estado', align: 'center', sortable: false, class: 'header_datatable' },
  { text: 'ver', value: 'action_ver', sortable: false, align: 'center', class: 'header_datatable', width: '50' },
  { text: 'configurar evaluación', value: 'action_configurar', sortable: false, align: 'center', class: 'header_datatable', width: '200' }

];

export const SelectorIncidenciaHeaders = [
  /* { text: 'INDEX', align: 'left', value: 'index', class:'secondary'},
  { text: 'ID', align: 'left', value: 'id', class:'secondary'}, */
  { text: 'seleccionar', value: 'action_select', class: 'header_datatable' },
  { text: 'código', value: 'id', align: 'left', class: 'header_datatable' },
  { text: 'descripción', value: 'descripcion', class: 'header_datatable' },
  { text: 'nivel', value: 'nivel_incidencia', class: 'header_datatable' },
];

export const RegIncidenciaConductheaders = [
  /* { text: 'INDEX', align: 'left', value: 'index', class:'secondary'},
  { text: 'ID', align: 'left', value: 'id', class:'secondary'}, */

  { text: 'n.º de documento de identidad', value: 'num_documento', class: 'header_datatable' },
  { text: 'apellidos y nombres', value: 'action_ap_nombre', class: 'header_datatable' },
  { text: 'tipo de incidencia', value: 'tipo_incidencia', class: 'header_datatable' },
  { text: 'fecha', value: 'fecha', align: 'center', class: 'header_datatable' },
  { text: 'nivel de incidencias', value: 'nivel_incidencia', align: 'center', class: 'header_datatable' },
  { text: 'puntaje', value: 'puntaje', align: 'center', class: 'header_datatable' },
  { text: 'ver', value: 'action_ver', sortable: false, align: 'center', class: 'header_datatable', width: '50' },
  { text: 'editar', value: 'action_editar', sortable: false, align: 'center', class: 'header_datatable', width: '50' },
  { text: 'eliminar', value: 'action_borrar', sortable: false, align: 'center', class: 'header_datatable', width: '50' }

];


export const seguimientoHeaders = [
  { text: 'acción', align: 'center', value: 'accion', class: 'header_datatable' },
  { text: 'motivo de reasignación', align: 'center', value: 'Estado', class: 'header_datatable' },
  { text: 'nombre del responsable', align: 'center', value: 'nombre_persona', class: 'header_datatable' },
  { text: 'n.° de documento de identidad', align: 'center', value: 'numdoc_persona', class: 'header_datatable' },
  { text: 'tipo', align: 'center', value: 'tipo_res', class: 'header_datatable' },
  { text: 'fecha', align: 'center', value: 'fecha', class: ' header_datatable' },
  { text: 'observación', align: 'center', value: 'observacion', class: 'header_datatable' },
];

export const profesoresHeaders = [
  { text: 'id', align: 'center', value: 'id', class: 'header_datatable' },
  { text: 'nombre del docente', align: 'center', value: 'nombre_apellido', class: 'header_datatable' },
  { text: 'n.° de documento de identidad', align: 'center', value: 'numdoc_persona', class: 'header_datatable' },
  { text: 'correo electrónico', align: 'center', value: 'correo_persona', class: 'header_datatable' },
  { text: 'teléfono móvil', align: 'center', value: 'telf_persona', class: 'header_datatable' },
  { text: 'acciones', align: 'center', value: 'accion', class: 'header_datatable' },
];


export const PlanlectorHeaders = [
  {
    text: "Titulo",
    value: "titulo",
    sortable: false,
    align: "center",
    class: "secundary black--text",
  },
  {
    text: "Genero",
    value: "genero",
    sortable: false,
    align: "center",
    class: "secundary black--text",
  },
  {
    text: "Audio",
    value: "audio",
    sortable: false,
    align: "center",
    class: "secundary black--text",
  },
  {
    text: "Imagen",
    value: "imagen",
    sortable: false,
    align: "center",
    class: "secundary black--text",
  },
  {
    text: "Estado",
    value: "estado",
    sortable: false,
    align: "center",
    class: "secundary black--text",
  },
  {
    text: "Lectura",
    value: "lectura",
    sortable: false,
    align: "center",
    class: "secundary black--text",
  },
  {
    text: "Opciones",
    value: "opciones",
    sortable: false,
    align: "center",
    class: "secundary black--text",
  },
];

export const SituacionFinalestudianteHeaders = [
  {
    text: "Nombre",
    value: "nombre_persona",
    class: "header_datatable",
  },
  {
    text: "Apellido Paterno",
    value: "ape1_persona",
    class: "header_datatable",
  },
  {
    text: "Apellido Materno",
    value: "ape2_persona",
    class: "header_datatable",
  },
  {
    text: "Nivel",
    value: "desc_nivel",
    class: "header_datatable",
  },
  {
    text: "Grado",
    value: "desc_grado",
    class: "header_datatable",
  },
  {
    text: "Seccion",
    value: "nombre_seccion",
    class: "header_datatable",
  },
  // {
  //   text: "Situacion",
  //   value: "situacion",
  //   class: "header_datatable",
  // },
];

// Carpeta
export const CarpetaEstudianteheadersDoc = [
  {
    text: "NOMBRE DEL DOCUMENTO",
    value: "nombre",
    class: "header_datatable",
  },
  { text: "VER DOCUMENTOS", value: "ruta", class: "header_datatable" },
];

export const CarpetaEvaluacionesHeaders = [
  { text: 'DOCENTE', value: 'profesor', class: 'header_datatable' },
  { text: 'EVALUACIÓN', value: 'nombre_evaluacion', align: 'center', class: 'header_datatable' },
  { text: 'FORMA', value: 'desc_forma', class: 'header_datatable' },
  { text: 'TIPO', value: 'desc_tipo', class: 'header_datatable' },
  { text: 'FECHA PROGRAMADA', value: 'fecha', align: 'center', class: 'header_datatable' },
  { text: 'HORA PROGRAMADA', value: 'action_hora', align: 'center', class: 'header_datatable' },
  { text: 'ESTADO', value: 'id_estado_evaluacion', align: 'center', class: 'header_datatable' },
  // { text: 'REALIZAR', value: 'action_evaluar', sortable: false, align: 'center', class: 'header_datatable px-0 mx-0', width: '80' },
  { text: 'VISUALIZAR', value: 'action_ver', sortable: false, align: 'center', class: 'header_datatable ', width: '80' },
  { text: 'NOTA', value: 'action_nota', sortable: false, align: 'center', class: 'header_datatable ', width: '80' }

];

export const SupervisionEstudiantesHeaders = [

  { text: "TEMA",align: "center",value: "nombre_clase", class: "header_datatable", },
  { text: 'DOCENTE', value: 'nombre_apellido_docente', sortable: false, align: 'center', class: 'header_datatable' },
  { text: "ACTIVIDAD",value: "tareaAsignada",align: "center",class: "header_datatable",},
  { text: "FECHA DE ENTREGA",value: "fechaEntrega",align: "center",class: "header_datatable",},
  { text: 'COMENTARIO DEL DOCENTE', value: 'comentarioDocente', sortable: false, align: 'center', class: 'header_datatable' },
  { text: "CALIFICACIÓN",value: "calificacion",align: "center", sortable: false, class: "header_datatable",},
  { text: "ESTADO",value: "estadoTarea", sortable: false, align: "center", class: "header_datatable",},
  { text: "ENTREGA", value: "tareaEnviada", sortable: false, align: "center", class: "blue lighten-4 black--text",},
  { text: "FECHA DE ENVÍO",value: "fechaEnvio",sortable: false, align: "center", class: "blue lighten-4 black--text",},
  { text: "COMENTARIO DEL ESTUDIANTE",value: "comentarioAlumno", sortable: false, align: "center", class: "blue lighten-4 black--text",},
];


export const PagospendientesHeaders = [
  { text: "AÑO", value: "nom_anolectivo", class: "header_datatable", sortable: false },
  { text: "MES", value: "nombre_mes", class: "header_datatable", sortable: false },
  { text: "NIVEL", value: "desc_nivel", class: "header_datatable", sortable: false },
  { text: "GRADO", value: "desc_grado", class: "header_datatable", sortable: false },
  { text: "SECCIÓN", value: "nombre_seccion", class: "header_datatable", sortable: false },
  { text: "DOCUMENTO DE IDENTIDAD", value: "documento_identidad", class: "header_datatable", sortable: false },
  { text: "NOMBRES Y APELLIDOS", value: "nombre_estudiante", class: "header_datatable", sortable: false },
  { text: "CONCEPTO", value: "concepto", class: "header_datatable", sortable: false },
  { text: "FECHA DE VENCIMIENTO", value: "fecha_vencimiento", sortable: false, class: "header_datatable" },
  { text: "MONTO", value: "monto", sortable: false, class: "header_datatable" },
  { text: "MORA", value: "mora", sortable: false, class: "header_datatable" },
  { text: "BECA", value: "beca", sortable: false, class: "header_datatable" },
  { text: "DTO.", value: "dcto", sortable: false, class: "header_datatable" },
  { text: "TOTAL", value: "total", sortable: false, class: "header_datatable" },
];

export const PagosRealizadosHeaders = [
  { text: "AÑO", value: "nom_anolectivo", class: "header_datatable", sortable: false },
  { text: "MES", value: "nombre_mes", class: "header_datatable", sortable: false },
  { text: "NIVEL", value: "desc_nivel", class: "header_datatable", sortable: false },
  { text: "GRADO", value: "desc_grado", class: "header_datatable", sortable: false },
  { text: "SECCIÓN", value: "nombre_seccion", class: "header_datatable", sortable: false },
  { text: "DOCUMENTO DE IDENTIDAD", value: "documento_identidad", class: "header_datatable", sortable: false },
  { text: "NOMBRES Y APELLIDOS", value: "nombre_estudiante", class: "header_datatable", sortable: false },
  { text: "FECHA DE PAGO", value: "fecha_pago", sortable: false, class: "header_datatable" },
  { text: "CONCEPTO", value: "concepto", class: "header_datatable", sortable: false },
  { text: "METODO DE PAGO", value: "nombre_metodo_pago", class: "header_datatable", sortable: false },
  { text: "MONEDA", value: "nombre_moneda", class: "header_datatable", sortable: false },
  { text: "MONTO PAGADO", value: "monto", sortable: false, class: "header_datatable" },
  { text: "VISUALIZAR BOLETA ELECTRÓNICA", value: "verpago", sortable: false, class: "header_datatable" },
  { text: "COMPROBANTE DE PAGO", value: "url_comprobante", sortable: false, class: "header_datatable" },
];

export const EstadodeCobrosHeaders = [
  { text: "AÑO", value: "nom_anolectivo", class: "header_datatable", sortable: false },
  { text: "MES", value: "nombre_mes", class: "header_datatable", sortable: false },
  { text: "NIVEL", value: "desc_nivel", class: "header_datatable", sortable: false },
  { text: "GRADO", value: "desc_grado", class: "header_datatable", sortable: false },
  { text: "SECCIÓN", value: "nombre_seccion", class: "header_datatable", sortable: false },
  { text: "DOCUMENTO DE IDENTIDAD", value: "documento_identidad", class: "header_datatable", sortable: false },
  { text: "NOMBRES Y APELLIDOS", value: "nombre_estudiante", class: "header_datatable", sortable: false },
  { text: "CONCEPTO", value: "concepto", class: "header_datatable", sortable: false },
  { text: "FECHA DE VENCIMIENTO", value: "fecha_vencimiento", sortable: false, class: "header_datatable" },
  { text: "MONEDA", value: "nombre_moneda", class: "header_datatable" },
  { text: "MONTO", value: "monto", sortable: false, class: "header_datatable" },
  { text: "MORA", value: "mora", sortable: false, class: "header_datatable" },
  { text: "BECA", value: "beca", sortable: false, class: "header_datatable" },
  { text: "DTO.", value: "dcto", sortable: false, class: "header_datatable" },
  { text: "TOTAL", value: "total", sortable: false, class: "header_datatable" },
  { text: "ESTADO", value: "estado", sortable: false, class: "header_datatable" },
];

export const IngresosEgresosHeaders = [
  { text: "TALONARIO", value: "serie", class: "header_datatable", sortable: false },
  { text: "DNI / RUC", value: "numero_documento", class: "header_datatable", sortable: false },
  { text: "NOMBRES Y APELLIDOS / NOMBRE COMERCIAL", value: "nombre_razon_social", class: "header_datatable", sortable: false },
  { text: "FECHA DE EMISIÓN", value: "fecha_emision", class: "header_datatable", sortable: false },
  { text: "NIVEL", value: "desc_nivel", align: "center", class: "header_datatable", sortable: false },
  { text: "GRADO", value: "desc_grado", align: "center", class: "header_datatable", sortable: false },
  { text: "SECCIÓN", value: "nombre_seccion", align: "center", class: "header_datatable", sortable: false },
  { text: "ESTUDIANTE", value: "nombre_estudiante", align: "center", class: "header_datatable", sortable: false },
  { text: "FORMA DE PAGO", value: "id_metodo_pago", align: "center", class: "header_datatable", sortable: false },
  { text: "MONTO", value: "monto", align: "center", class: "header_datatable", sortable: false },
  { text: "EDITAR", value: "action_editar", sortable: false, align: "center", class: "header_datatable px-0 mx-0", width: "1" }
];

export const AcuerdosPagadosHeaders = [
  { text: "NIVEL", value: "desc_nivel", class: "header_datatable" },
  { text: "GRADO", value: "desc_grado", class: "header_datatable" },
  { text: "SECCIÓN", value: "nombre_seccion", class: "header_datatable" },
  { text: "DOCUMENTO", value: "numero_documento_estudiante", class: "header_datatable" },
  { text: "ESTUDIANTE", value: "nombre_estudiante", align: "center", class: "header_datatable" },
  { text: "FECHA DEL ACUERDO DE PAGO", value: "fecha_acuerdo", align: "center", class: "header_datatable" },
  { text: "FECHA DE VENCIMIENTO", value: "fecha_vencimiento", align: "center", class: "header_datatable" },
  { text: "NRO. DE CUOTAS", value: "nro_cuotas", align: "center", class: "header_datatable" },
  { text: "MONTO TOTAL", value: "monto", align: "center", class: "header_datatable" },
  { text: "EDITAR", value: "action_editar", sortable: false, align: "center", class: "header_datatable px-0 mx-0", width: "1" }
];

export const AcuerdosPagadosDetailHeader = [
  { text: "CONCEPTO", value: "concepto", class: "header_datatable" },
  { text: "FECHA DE VENCIMIENTO", value: "fecha_vencimiento", class: "header_datatable" },
  { text: "MONTO", value: "monto", class: "header_datatable" }
];

export const CreditoDebitoHeaders = [
  { text: "NIVEL", value: "desc_nivel", align: "center", class: "header_datatable" },
  { text: "GRADO", value: "desc_grado", align: "center", class: "header_datatable" },
  { text: "SECCIÓN", value: "nombre_seccion", align: "center", class: "header_datatable" },
  { text: "DOCUMENTO", value: "documento_identidad", class: "header_datatable" },
  { text: "ESTUDIANTE", value: "nombre_estudiante", align: "center", class: "header_datatable" },
  { text: "FECHA EMISIÓN", value: "fecha_emision", class: "header_datatable" },
  { text: "MONTO", value: "monto", align: "center", class: "header_datatable" },
  { text: "MOTIVO", value: "motivo", align: "center", class: "header_datatable" },
  { text: "EDITAR", value: "action_editar", sortable: false, align: "center", class: "header_datatable px-0 mx-0", width: "1" }
];

export const PagosHeaders = [
  { text: "AÑO", value: "nom_anolectivo", class: "header_datatable", sortable: false, },
  { text: "NOMBRES Y APELLIDOS", value: "nombre_estudiante", class: "header_datatable", sortable: false, },
  { text: "CONCEPTO", value: "concepto", class: "header_datatable", sortable: false, },
  { text: "FECHA DE VENCIMIENTO", value: "fecha_vencimiento", sortable: false, class: "header_datatable" },
  { text: "MONEDA", value: "nombre_moneda", sortable: false, class: "header_datatable" },
  { text: "MONTO A PAGAR", value: "monto", sortable: false, class: "header_datatable" },
  { text: "ESTADO", value: "estado", sortable: false, class: "header_datatable" },
  { text: "PAGAR", value: "pago_efectivo", sortable: false, class: "header_datatable" },
  { text: "VER BOLETA ELECTRÓNICA", value: "verpago", sortable: false, class: "header_datatable" }
];

export const DebitoautomaticoHeaders = [
  { text: "AÑO", value: "nom_anolectivo", class: "header_datatable" },
  { text: "N.° DE DOCUMENTO DE IDENTIDAD", value: "numero_documento", class: "header_datatable" },
  { text: "ESTUDIANTE", value: "nombre_estudiante", class: "header_datatable" },
  { text: "FECHA DE INICIO", value: "fecha_inicio", sortable: false, class: "header_datatable" },
  { text: "FECHA DE FINALIZACIÓN", value: "fecha_fin", sortable: false, class: "header_datatable" },
  { text: "BANCO", value: "nombre_banco", sortable: false, class: "header_datatable" },
  { text: "N.° DE CUENTA", value: "numero_cuenta", sortable: false, class: "header_datatable" },
  { text: "ESTADO", value: "estado", sortable: false, class: "header_datatable" },
  { text: "VISUALIZAR", value: "action_editar", sortable: false, class: "header_datatable" }
];

// Metricas headers
export const HeadersRankeds = [
  { text: "NOMBRE Y APELLIDOS", value: "nombre_completo", class: "header_datatable", align: "center" },
  // { text: "SECCIÓN", value: "nombre_seccion", class: "header_datatable", align: "center" },
  { text: "PROMEDIO", value: "prom_notas_alumno", class: "header_datatable", align: "center" },
  { text: "N.° DE EVALUACIONES", value: "total_eval", class: "header_datatable", align: "center" },
  { text: "POSICIÓN", value: "rank_alumno", class: "header_datatable", align: "center" },
];
export const headerActividadesMeticas = [
  { text: "ÁREA", value: "desc_area", class: "header_datatable", align: "center" },
  { text: "CURSO", value: "desc_curso", class: "header_datatable", align: "center" },
  { text: "CLASE", value: "nombre_clase", class: "header_datatable", align: "center" },
  { text: "TEMA", value: "nombre_tema", class: "header_datatable", align: "center" },
  { text: "ACTIVIDAD", value: "desc_tipo_actividad", class: "header_datatable", align: "center" },
  { text: "ESTADO", value: "desc_estado_docente", class: "header_datatable", align: "center" },
  { text: "CALIFICACIÓN", value: "calificacion_revision", class: "header_datatable", align: "center" },
];

export const CurvadaprendizajeHeaders = [
  // { text: "examen", value: "idexamen", class: "header_datatable", align: "center", sortable: false, },
  { text: "fecha", value: "fecha_creacion", class: "header_datatable", sortable: false, align: "center" },
  { text: "preguntas correctas", value: "verdaderas", class: "header_datatable", sortable: false, align: "center" },
  { text: "preguntas incorrectas", value: "falsas", class: "header_datatable", sortable: false, align: "center" },
  { text: "Resultado", value: "aprobado", class: "header_datatable", sortable: false, align: "center" },
];